webpackJsonp([1],{

/***/ "14gb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EventBus; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");


var EventBus = new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]();

/***/ }),

/***/ "14xJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'main_page',
  data: function data() {
    this.$parent.active_tab = 'main_page';
    return {
      activeTab: 0
    };
  }
});

/***/ }),

/***/ "2KWe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":this.id}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "2fz6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "3/GJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{attrs:{"action":""}},[_c('div',{staticClass:"modal-card"},[_vm._m(0),_vm._v(" "),_c('section',{staticClass:"modal-card-body"},[_c('b-field',{attrs:{"label":"Логин"}},[_c('b-input',{attrs:{"type":"text","placeholder":"Ваш логин","required":""},model:{value:(_vm.username),callback:function ($$v) {_vm.username=$$v},expression:"username"}})],1),_vm._v(" "),_c('b-field',{attrs:{"label":"Пароль"}},[_c('b-input',{attrs:{"type":"password","password-reveal":"","placeholder":"Ваш пароль","required":""},model:{value:(_vm.password),callback:function ($$v) {_vm.password=$$v},expression:"password"}})],1)],1),_vm._v(" "),_c('footer',{staticClass:"modal-card-foot"},[_c('button',{staticClass:"button is-primary",on:{"click":function($event){_vm.sign_in(_vm.username, _vm.password)}}},[_vm._v("Войти")])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"modal-card-head"},[_c('p',{staticClass:"modal-card-title"},[_vm._v("Вход")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "3j2k":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tests is-margin-top"},[_c('section',[_c('div',{staticClass:"container",attrs:{"id":"#test_container"}},[_c('div',{staticClass:"columns is-margin-top"},[_c('div',{staticClass:"column is-half"},[_c('nav',{staticClass:"breadcrumb",attrs:{"aria-label":"breadcrumbs"}},[_c('ul',[_c('li',{staticClass:"is-active"},[_c('button',{staticClass:"button",attrs:{"id":"refresh_button"},on:{"click":function($event){_vm.fetch_data()}}},[_c('b-icon',{attrs:{"icon":"refresh"}})],1),_c('a',{attrs:{"href":"#/tests","aria-current":"page"}},[_vm._v("Тесты")])])])]),_vm._v(" "),_c('div',[_c('b-table',{attrs:{"data":_vm.data_tests,"selected":_vm.selected_test,"paginated":"","loading":_vm.data_loading},on:{"update:selected":function($event){_vm.selected_test=$event}},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('b-table-column',{attrs:{"label":"Наименование теста","field":"name","sortable":""}},[_vm._v("\n                  "+_vm._s(props.row.name)+"\n                ")]),_vm._v(" "),_c('b-table-column',{attrs:{"label":"Кол-во вопросов","field":"length","numeric":"","sortable":""}},[_vm._v("\n                  "+_vm._s(props.row.length)+"\n                ")]),_vm._v(" "),_c('b-table-column',{attrs:{"label":"Дата изменения","field":"changed","sortable":""}},[_vm._v("\n                  "+_vm._s(new Date(props.row.changed).toLocaleString())+"\n                ")]),_vm._v(" "),_c('b-table-column',{attrs:{"label":"Сложность","field":"level","numeric":""}},[_vm._v("\n                  "+_vm._s(props.row.level)+"\n                ")]),_vm._v(" "),_c('b-table-column',{attrs:{"field":"active","label":"Активен"}},[_c('b-checkbox',{attrs:{"disabled":""},model:{value:(props.row.active),callback:function ($$v) {_vm.$set(props.row, "active", $$v)},expression:"props.row.active"}})],1)]}}])})],1)]),_vm._v(" "),_c('div',{staticClass:"column is-half"},[_c('section',{staticClass:"is-margin-top"},[_c('button',{staticClass:"button",on:{"click":function($event){_vm.add_test_button_click()}}},[_vm._v("+ Добавить тест")])]),_vm._v(" "),_c('section',{staticClass:"is-margin-top box fast_edit"},[(_vm.selected_test.hasOwnProperty("name"))?_c('b-tabs',{staticClass:"block",attrs:{"animated":false}},[_c('b-tab-item',{attrs:{"label":"Основные"}},[_c('div',[_c('b-field',{staticClass:"is-margin-top",attrs:{"label":"Наименование теста"}},[_c('b-input',{attrs:{"placeholder":"Наименование теста"},model:{value:(_vm.selected_test.name),callback:function ($$v) {_vm.$set(_vm.selected_test, "name", $$v)},expression:"selected_test.name"}})],1),_vm._v(" "),_c('b-field',{attrs:{"label":"Кол-во вопросов"}},[_vm._v("\n                    "+_vm._s(_vm.selected_test.length)+"\n                  ")]),_vm._v(" "),_c('b-field',{attrs:{"label":"Дата изменения"}},[_vm._v("\n                    "+_vm._s(new Date(_vm.selected_test.changed).toLocaleString())+"\n                  ")]),_vm._v(" "),_c('b-field',{attrs:{"label":"Сложность"}},[_c('b-input',{attrs:{"placeholder":"Сложность","type":"number","min":"0","max":"5"},model:{value:(_vm.selected_test.level),callback:function ($$v) {_vm.$set(_vm.selected_test, "level", $$v)},expression:"selected_test.level"}})],1),_vm._v(" "),_c('b-field',{attrs:{"label":"Привязка к комнатам (через запятую)"}},[_c('b-input',{attrs:{"placeholder":"Комната"},model:{value:(_vm.selected_test.room),callback:function ($$v) {_vm.$set(_vm.selected_test, "room", $$v)},expression:"selected_test.room"}})],1),_vm._v(" "),_c('b-field',{attrs:{"label":"Активен"}},[_c('b-switch',{model:{value:(_vm.selected_test.active),callback:function ($$v) {_vm.$set(_vm.selected_test, "active", $$v)},expression:"selected_test.active"}})],1),_vm._v(" "),_c('b-field',[_c('media-uploader',{attrs:{"label":"При открытии"},model:{value:(_vm.selected_test.on_open),callback:function ($$v) {_vm.$set(_vm.selected_test, "on_open", $$v)},expression:"selected_test.on_open"}})],1),_vm._v(" "),_c('b-field',[_c('media-uploader',{attrs:{"label":"Результат (верно)"},model:{value:(_vm.selected_test.on_pass),callback:function ($$v) {_vm.$set(_vm.selected_test, "on_pass", $$v)},expression:"selected_test.on_pass"}})],1),_vm._v(" "),_c('b-field',[_c('media-uploader',{attrs:{"label":"Результат (неверно)"},model:{value:(_vm.selected_test.on_fail),callback:function ($$v) {_vm.$set(_vm.selected_test, "on_fail", $$v)},expression:"selected_test.on_fail"}})],1)],1)]),_vm._v(" "),_c('b-tab-item',{attrs:{"label":"Описание"}},[_c('media-uploader',{staticClass:"is-margin-top",attrs:{"label":"Картинка для меню [200x200]","files":["image"]},model:{value:(_vm.selected_test.image),callback:function ($$v) {_vm.$set(_vm.selected_test, "image", $$v)},expression:"selected_test.image"}}),_vm._v(" "),_c('b-field',{attrs:{"label":"Краткое описание"}},[_c('b-input',{attrs:{"maxlength":"200","type":"textarea"},model:{value:(_vm.selected_test.description),callback:function ($$v) {_vm.$set(_vm.selected_test, "description", $$v)},expression:"selected_test.description"}})],1)],1),_vm._v(" "),_c('b-tab-item',{attrs:{"label":"Параметры"}},[_c('b-field',{attrs:{"label":"Цена участия"}},[_c('b-input',{attrs:{"type":"number"},model:{value:(_vm.selected_test.price),callback:function ($$v) {_vm.$set(_vm.selected_test, "price", $$v)},expression:"selected_test.price"}})],1),_vm._v(" "),_c('b-field',{attrs:{"label":"Приз за участие"}},[_c('b-input',{attrs:{"type":"number"},model:{value:(_vm.selected_test.prize),callback:function ($$v) {_vm.$set(_vm.selected_test, "prize", $$v)},expression:"selected_test.prize"}})],1)],1),_vm._v(" "),_c('b-tab-item',{attrs:{"label":"Вопросы"}},[_c('div',[_c('div',{staticClass:"field has-addons"},[_c('div',{staticClass:"control"},[_c('button',{staticClass:"button",on:{"click":_vm.prev_question}},[_vm._v(" ← ")])]),_vm._v(" "),_c('div',{staticClass:"control"},[_c('b-input',{staticStyle:{"width":"45px"},model:{value:(_vm.question_id),callback:function ($$v) {_vm.question_id=$$v},expression:"question_id"}})],1),_vm._v(" "),_c('div',{staticClass:"control"},[_c('button',{staticClass:"button",on:{"click":function($event){_vm.is_question_search = true}}},[_vm._v(" поиск ")])]),_vm._v(" "),_c('div',{staticClass:"control"},[_c('button',{staticClass:"button",on:{"click":_vm.next_question}},[_vm._v(" → ")])])])]),_vm._v(" "),(_vm.current_question !== null)?_c('div',{staticClass:"is-margin-top box"},[_c('b-field',[_c('button',{staticClass:"delete is-pulled-right",on:{"click":function($event){_vm.delete_question(_vm.current_question)}}})]),_vm._v(" "),(_vm.selected_test.hasOwnProperty("name"))?_c('b-tabs',{staticClass:"block",attrs:{"position":"is-right","animated":false}},[_c('b-tab-item',{attrs:{"label":"Текст"}},[_c('b-field',{staticClass:"is-margin-top"},[_c('b-input',{attrs:{"placeholder":"Вопрос","maxlength":"200","type":"textarea"},model:{value:(_vm.current_question.text),callback:function ($$v) {_vm.$set(_vm.current_question, "text", $$v)},expression:"current_question.text"}})],1),_vm._v(" "),_c('b-field',{attrs:{"label":"Правильный ответ"}},[_c('b-field',[_c('b-radio-button',{attrs:{"native-value":1},model:{value:(_vm.current_question.right_answer),callback:function ($$v) {_vm.$set(_vm.current_question, "right_answer", $$v)},expression:"current_question.right_answer"}},[_vm._v("1")]),_vm._v(" "),_c('b-radio-button',{attrs:{"native-value":2},model:{value:(_vm.current_question.right_answer),callback:function ($$v) {_vm.$set(_vm.current_question, "right_answer", $$v)},expression:"current_question.right_answer"}},[_vm._v("2")]),_vm._v(" "),_c('b-radio-button',{attrs:{"native-value":3},model:{value:(_vm.current_question.right_answer),callback:function ($$v) {_vm.$set(_vm.current_question, "right_answer", $$v)},expression:"current_question.right_answer"}},[_vm._v("3")]),_vm._v(" "),_c('b-radio-button',{attrs:{"native-value":4},model:{value:(_vm.current_question.right_answer),callback:function ($$v) {_vm.$set(_vm.current_question, "right_answer", $$v)},expression:"current_question.right_answer"}},[_vm._v("4")])],1)],1),_vm._v(" "),_c('b-field',[_c('b-input',{attrs:{"placeholder":"Ответ 1","type":"text"},model:{value:(_vm.current_question.answer1_text),callback:function ($$v) {_vm.$set(_vm.current_question, "answer1_text", $$v)},expression:"current_question.answer1_text"}})],1),_vm._v(" "),_c('b-field',[_c('b-input',{attrs:{"placeholder":"Ответ 2","type":"text"},model:{value:(_vm.current_question.answer2_text),callback:function ($$v) {_vm.$set(_vm.current_question, "answer2_text", $$v)},expression:"current_question.answer2_text"}})],1),_vm._v(" "),_c('b-field',[_c('b-input',{attrs:{"placeholder":"Ответ 3","type":"text"},model:{value:(_vm.current_question.answer3_text),callback:function ($$v) {_vm.$set(_vm.current_question, "answer3_text", $$v)},expression:"current_question.answer3_text"}})],1),_vm._v(" "),_c('b-field',[_c('b-input',{attrs:{"placeholder":"Ответ 4","type":"text"},model:{value:(_vm.current_question.answer4_text),callback:function ($$v) {_vm.$set(_vm.current_question, "answer4_text", $$v)},expression:"current_question.answer4_text"}})],1)],1),_vm._v(" "),_c('b-tab-item',{attrs:{"label":"Медиа"}},[_c('media-uploader',{staticClass:"is-margin-top",attrs:{"label":"Вопрос"},model:{value:(_vm.current_question.on_open),callback:function ($$v) {_vm.$set(_vm.current_question, "on_open", $$v)},expression:"current_question.on_open"}}),_vm._v(" "),_c('media-uploader',{staticClass:"is-margin-top",attrs:{"label":"Аудио - Ответ 1","files":["audio"]},model:{value:(_vm.current_question.answer1_media),callback:function ($$v) {_vm.$set(_vm.current_question, "answer1_media", $$v)},expression:"current_question.answer1_media"}}),_vm._v(" "),_c('media-uploader',{staticClass:"is-margin-top",attrs:{"label":"Аудио - Ответ 2","files":["audio"]},model:{value:(_vm.current_question.answer2_media),callback:function ($$v) {_vm.$set(_vm.current_question, "answer2_media", $$v)},expression:"current_question.answer2_media"}}),_vm._v(" "),_c('media-uploader',{staticClass:"is-margin-top",attrs:{"label":"Аудио - Ответ 3","files":["audio"]},model:{value:(_vm.current_question.answer3_media),callback:function ($$v) {_vm.$set(_vm.current_question, "answer3_media", $$v)},expression:"current_question.answer3_media"}}),_vm._v(" "),_c('media-uploader',{staticClass:"is-margin-top",attrs:{"label":"Аудио - Ответ 4","files":["audio"]},model:{value:(_vm.current_question.answer4_media),callback:function ($$v) {_vm.$set(_vm.current_question, "answer4_media", $$v)},expression:"current_question.answer4_media"}}),_vm._v(" "),_c('media-uploader',{staticClass:"is-margin-top",attrs:{"label":"Результат (верно)"},model:{value:(_vm.current_question.on_pass),callback:function ($$v) {_vm.$set(_vm.current_question, "on_pass", $$v)},expression:"current_question.on_pass"}}),_vm._v(" "),_c('media-uploader',{staticClass:"is-margin-top",attrs:{"label":"Результат (неверно)"},model:{value:(_vm.current_question.on_fail),callback:function ($$v) {_vm.$set(_vm.current_question, "on_fail", $$v)},expression:"current_question.on_fail"}})],1)],1):_vm._e()],1):_c('div',{staticClass:"notification is-margin-top"},[_vm._v("\n                  Вопроса под таким номером не существует.\n                ")]),_vm._v(" "),_c('button',{staticClass:"button",on:{"click":function($event){_vm.add_question_to_selected_test()}}},[_vm._v("+ Добавить вопрос")])]),_vm._v(" "),_c('button',{staticClass:"button is-primary is-margin-top",on:{"click":function($event){_vm.save_selected_test()}}},[_vm._v("Сохранить")])],1):_c('div',{staticClass:"is-margin-top notification"},[_vm._v("\n              Выберите тест для быстрого редактирования.\n            ")])],1)]),_vm._v(" "),_c('b-modal',{attrs:{"active":_vm.is_asking_for_test_name,"width":640,"scroll":"keep"},on:{"update:active":function($event){_vm.is_asking_for_test_name=$event}}},[_c('div',{staticClass:"card"},[_c('header',{staticClass:"card-header"},[_c('p',{staticClass:"card-header-title"},[_vm._v("\n                Создать новый тест\n              ")])]),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('b-field',{attrs:{"label":"Название теста"}},[_c('b-input',{attrs:{"placeholder":"Название теста","type":"text"},model:{value:(_vm.new_test_name),callback:function ($$v) {_vm.new_test_name=$$v},expression:"new_test_name"}})],1)],1),_vm._v(" "),_c('footer',{staticClass:"card-footer"},[_c('a',{staticClass:"card-footer-item",on:{"click":function($event){_vm.close_new_test_modal()}}},[_vm._v("Отмена")]),_vm._v(" "),_c('a',{staticClass:"card-footer-item",on:{"click":function($event){_vm.create_test()}}},[_vm._v("Создать")])])])])],1)]),_vm._v(" "),_c('b-modal',{attrs:{"active":_vm.is_question_search},on:{"update:active":function($event){_vm.is_question_search=$event}}},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content"},[_c('b-table',{attrs:{"data":_vm.questions_table,"bordered":true,"stripped":true,"paginated":true,"per-page":10},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('b-table-column',{attrs:{"field":"id","label":"ID","width":"40","numeric":""}},[_vm._v("\n                  "+_vm._s(props.row.id)+"\n              ")]),_vm._v(" "),_c('b-table-column',{attrs:{"field":"name","label":"name"}},[_c('a',{on:{"click":function($event){_vm.select_question_id(props.row.id)}}},[_vm._v(_vm._s(props.row.name))])])]}}])})],1)])])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "54CK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Chart__ = __webpack_require__("h8rG");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Chart__["a"]; });


/***/ }),

/***/ "5DNF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"stats is-margin-top"},[_c('section',[_c('div',{staticClass:"container"})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "6aAP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return mixin; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_frappe_charts_dist_frappe_charts_min_esm__ = __webpack_require__("aw84");


var _props;



var mixin = {
    props: (_props = {
        id: {
            required: true,
            type: String,
            default: null
        },

        dataSets: {
            required: true,
            type: Array,
            default: function _default() {
                return [];
            }
        },

        labels: {
            required: true,
            type: Array,
            default: function _default() {
                return [];
            }
        },

        title: {
            required: false,
            type: String
        },

        height: {
            required: false,
            type: Number,
            default: 300
        },

        type: {
            required: false,
            type: String,
            default: 'bar'
        },

        yMarkers: {
            required: false,
            type: Array,
            default: function _default() {
                return [{
                    label: 'Marker',
                    value: 70,
                    options: {
                        labelPos: 'left'
                    }
                }];
            }
        },

        yRegions: {
            required: false,
            type: Array,
            default: function _default() {
                return [{
                    label: 'Region',
                    start: -10,
                    end: 50,
                    options: {
                        labelPos: 'right'
                    }
                }];
            }
        },

        colors: {
            required: false,
            type: Array,
            default: function _default() {
                return ['purple', '#ffa3ef', 'light-blue'];
            }
        },

        isNavigable: {
            required: false,
            type: Boolean,
            default: false
        },

        valuesOverPoints: {
            required: false,
            type: Boolean,
            default: false
        },

        barOptions: {
            required: false,
            type: Object,
            default: function _default() {
                return {
                    spaceRatio: 0.5,
                    stacked: 0
                };
            }
        },

        lineOptions: {
            required: false,
            type: Object,
            default: function _default() {
                return {
                    dotSize: 4,
                    hideLine: 0,
                    hideDots: 0,
                    heatline: 0,
                    regionFill: 0,
                    areaFill: 0
                };
            }
        },

        axisOptions: {
            required: false,
            type: Object,
            default: function _default() {
                return {
                    yAxisMode: '',
                    xAxisMode: '',
                    xIsSeries: 0
                };
            }
        },

        maxLegendPoints: {
            required: false,
            type: Number,
            default: 20
        },

        maxSlices: {
            required: false,
            type: Number,
            default: 20
        }

    }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_props, 'barOptions', {
        required: false,
        type: Object,
        default: function _default() {
            return {
                height: 20,
                depth: 2
            };
        }
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_props, 'discreteDomains', {
        required: false,
        type: Boolean,
        default: true
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_props, 'tooltipOptions', {
        required: false,
        type: Object,
        default: function _default() {
            return {
                formatTooltipX: function formatTooltipX(d) {
                    return (d + '').toUpperCase();
                },
                formatTooltipY: function formatTooltipY(d) {
                    return d + ' pts';
                }
            };
        }
    }), _props),

    data: function data() {
        return {
            chart: null,
            data: {
                labels: this.labels,
                datasets: this.dataSets
            }
        };
    },
    mounted: function mounted() {
        this.startChart();
    },


    methods: {
        startChart: function startChart() {
            var _ref;

            this.chart = new __WEBPACK_IMPORTED_MODULE_1_frappe_charts_dist_frappe_charts_min_esm__["a" /* Chart */]('#' + this.id, (_ref = {
                data: this.data,
                type: this.type,
                title: this.title,
                colors: this.colors,
                height: this.height,
                tooltipOptions: this.tooltipOptions,
                isNavigable: this.isNavigable,
                valuesOverPoints: this.valuesOverPoints,
                barOptions: this.barOptions,
                lineOptions: this.lineOptions,
                axisOptions: this.axisOptions,
                maxLegendPoints: this.maxLegendPoints,
                maxSlices: this.maxSlices
            }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'barOptions', this.barOptions), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'discreteDomains', this.discreteDomains), _ref));
        },
        export: function _export() {
            this.chart.export();
        },
        addDataPoint: function addDataPoint(label, valueFromEachDataset, index) {
            this.chart.addDataPoint(label, valueFromEachDataset, index);
        },
        removeDataPoint: function removeDataPoint(index) {
            this.chart.removeDataPoint(index);
        },
        updateDataset: function updateDataset(datasetValues, index) {
            this.chart.updateDataset(datasetValues, index);
        },
        unbindWindowEvents: function unbindWindowEvents() {
            this.chart.unbindWindowEvents();
        }
    }
};

/***/ }),

/***/ "7knd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__webcam__ = __webpack_require__("jvAN");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'photo',
  props: {
    value: {
      type: Object,
      default: function _default() {
        return this.empty_media;
      }
    }
  },
  components: {
    webcam: __WEBPACK_IMPORTED_MODULE_0__webcam__["a" /* default */]
  },
  data: function data() {
    return {
      static: window.static,
      p: null,
      is_taking_photo: false,
      empty_media: { audio: { name: '', filename: '', filetype: '', filesize: 0 }, video: { name: '', filename: '', filetype: '', filesize: 0 }, image: { name: '', filename: '', filetype: '', filesize: 0 } }
    };
  },
  methods: {
    u_name: function u_name() {
      return '_' + Math.random().toString(14).substr(2, 9);
    },
    prepare_file: function prepare_file() {
      var p = this.$refs.webcam.capture();
      this.is_taking_photo = false;
      // p = p.replace('data:image/jpeg;base64,', '')
      p = atob(p.split(',')[1]);
      var ab = new ArrayBuffer(p.length);
      var ia = new Uint8Array(ab);
      for (var i = 0; i < p.length; i++) {
        ia[i] = p.charCodeAt(i);
      }
      var file = {};
      file.name = this.u_name() + '.jpeg';
      file.size = p.length;
      file.type = 'image/jpeg';
      file.data = new Blob([ab], { type: 'image/jpeg' });
      return file;
    },
    photo: function photo() {
      var _this = this;
      var xhr = new XMLHttpRequest();
      var file = this.prepare_file();
      xhr.open('PUT', window.gw + 'api/upload/' + file.name, true);
      xhr.setRequestHeader('Content-Type', file.type);
      xhr.setRequestHeader('Content-Range', 'bytes 0-' + (file.size - 1) + '/' + file.size);
      xhr.onload = function (e) {
        console.log('upload complete', e);
        var d = JSON.parse(e.currentTarget.response);
        if (d.result === 'ok') {
          var f = d.params.file;
          _this.value.image.name = f.real_filename;
          _this.value.image.filename = f.filename;
          _this.value.image.filesize = f.filesize;
          _this.value.image.filetype = f.filetype;
          _this.$emit('input', _this.value);
          console.log(_this.value);
        }
        // _this.progress['image'].loading = false
      };
      xhr.onerror = function (e) {
        console.log('upload error', e);
        // _this.progress['image'].loading = false
      };
      xhr.send(file.data);
    }
  }
});

/***/ }),

/***/ "BDuk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map__ = __webpack_require__("ifoU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);




var Emitter = function () {
  function Emitter() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Emitter);

    this.listeners = new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map___default.a();
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Emitter, [{
    key: 'addListener',
    value: function addListener(label, callback, vm) {
      if (typeof callback === 'function') {
        this.listeners.has(label) || this.listeners.set(label, []);
        this.listeners.get(label).push({ callback: callback, vm: vm });
        return true;
      }
      return false;
    }
  }, {
    key: 'removeListener',
    value: function removeListener(label, callback, vm) {
      var listeners = this.listeners.get(label);
      var index = void 0;

      if (listeners && listeners.length) {
        index = listeners.reduce(function (i, listener, index) {
          if (typeof listener.callback === 'function' && listener.callback === callback && listener.vm === vm) {
            i = index;
          }
          return i;
        }, -1);

        if (index > -1) {
          listeners.splice(index, 1);
          this.listeners.set(label, listeners);
          return true;
        }
      }
      return false;
    }
  }, {
    key: 'emit',
    value: function emit(label) {
      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      var listeners = this.listeners.get(label);

      if (listeners && listeners.length) {
        listeners.forEach(function (listener) {
          var _listener$callback;

          (_listener$callback = listener.callback).call.apply(_listener$callback, [listener.vm].concat(args));
        });
        return true;
      }
      return false;
    }
  }]);

  return Emitter;
}();

/* harmony default export */ __webpack_exports__["a"] = (new Emitter());

/***/ }),

/***/ "DFBn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('section',{staticClass:"hero is-primary is-bald"},[_c('nav',{staticClass:"navbar",attrs:{"role":"navigation","aria-label":"main navigation"}},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"navbar-end"},[_c('b-dropdown',{attrs:{"position":"is-bottom-left"},model:{value:(_vm.navigation),callback:function ($$v) {_vm.navigation=$$v},expression:"navigation"}},[_c('a',{staticClass:"navbar-item",attrs:{"slot":"trigger"},slot:"trigger"},[_c('span',[_vm._v("Пользователь")]),_vm._v(" "),_c('b-icon',{attrs:{"icon":"menu-down"}})],1),_vm._v(" "),_c('b-dropdown-item',{attrs:{"custom":""}},[_vm._v("\n            В сети как "),_c('b',[_vm._v(_vm._s(_vm.current_user))])]),_vm._v(" "),_c('hr',{staticClass:"dropdown-divider"}),_vm._v(" "),_c('b-dropdown-item',{attrs:{"value":"logout"},on:{"click":function($event){_vm.logout()}}},[_c('b-icon',{attrs:{"icon":"logout"}}),_vm._v("\n            Выйти\n          ")],1)],1)],1)]),_vm._v(" "),_c('div',{staticClass:"hero-foot"},[_c('nav',{staticClass:"tabs  is-boxed"},[_c('div',{staticClass:"container"},[_c('ul',[_c('li',{class:_vm.active_tab_class("main_page")},[_c('router-link',{attrs:{"to":{ path: 'home' }}},[_c('b-icon',{attrs:{"icon":"home"}})],1)],1),_vm._v(" "),_c('li',{class:_vm.active_tab_class("users")},[_c('router-link',{attrs:{"to":{ path: 'users' }}},[_vm._v("Пользователи")])],1),_vm._v(" "),_c('li',{class:_vm.active_tab_class("tests")},[_c('router-link',{attrs:{"to":{ path: 'tests' }}},[_vm._v("Тесты")])],1),_vm._v(" "),_c('li',{class:_vm.active_tab_class("devices")},[_c('router-link',{attrs:{"to":{ path: 'devices' }}},[_vm._v("Устройства")])],1),_vm._v(" "),_c('li',{class:_vm.active_tab_class("cars")},[_c('router-link',{attrs:{"to":{ path: 'cars' }}},[_vm._v("Машины")])],1),_vm._v(" "),_c('li',{class:_vm.active_tab_class("stats")},[_c('router-link',{attrs:{"to":{ path: 'stats' }}},[_vm._v("Статистика")])],1)])])])])]),_vm._v(" "),_c('router-view'),_vm._v(" "),_c('transition',{attrs:{"name":"fade"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.login_overlay),expression:"login_overlay"}],staticClass:"back-overlay"})]),_vm._v(" "),_c('b-modal',{attrs:{"active":_vm.is_waiting_for_card,"width":640,"scroll":"keep"},on:{"update:active":function($event){_vm.is_waiting_for_card=$event}}},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content"},[_vm._v("\n        Приложите карту к считывателю\n      ")])])])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"navbar-brand"},[_c('a',{staticClass:"navbar-item"},[_vm._v("\n          ЦУП\n        ")]),_vm._v(" "),_c('button',{staticClass:"button navbar-burger"},[_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span')])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "DXcx":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "E1qT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__bus__ = __webpack_require__("14gb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store__ = __webpack_require__("olkN");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'cars',
  data: function data() {
    this.$parent.active_tab = 'cars';
    __WEBPACK_IMPORTED_MODULE_1__bus__["a" /* EventBus */].$on('ws_on_message', this.ws_on_message);
    this.fetch_data();
    return {
      store: __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */],
      cars: [],
      data_loading: true,
      empty_new_car: { name: '', car_type: '', active: false, size: '', number: '0' },
      new_car: { name: '', car_type: '', active: false, size: '', number: '0' },
      selected_car: {},
      activeTab: '',
      is_waiting_for_card: false,
      reader_target: null,
      car_types: [{ value: 'manual', label: 'Вело' }, { value: 'electro', label: 'Электро' }],
      car_sizes: [{ value: 'small', label: 'Маленькая' }, { value: 'middle', label: 'Средняя' }, { value: 'big', label: 'Большая' }],
      dict_car_size: { 'small': 'Маленькая', 'middle': 'Средняя', 'big': 'Большая' },
      dict_car_type: { 'manual': 'Вело', 'electro': 'Электро' }
    };
  },

  methods: {
    fetch_data: function fetch_data() {
      var t = this;
      t.data_loading = true;
      var form = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({ method: 'admin_get_cars', params: {} });
      window.$.post(window.gw + 'api/car', { data: form }, function (r) {
        var d = JSON.parse(r);
        if (d.result === 'ok') {
          t.cars = d.params.cars;
          t.data_loading = false;
        }
      });
      return;
    },
    save_car: function save_car() {
      var _t = this;
      _t.data_loading = true;
      var form = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({ method: 'admin_save_car', params: { car: _t.selected_car } });
      window.$.post(window.gw + 'api/car', { data: form }, function (r) {
        var d = JSON.parse(r);
        if (d.result === 'ok') {
          _t.data_loading = false;
          _t.$toast.open({
            duration: 1000,
            message: 'Готово!',
            position: 'is-top',
            type: 'is-success'
          });
        }
      });
      return;
    },
    add_car: function add_car() {
      var _t = this;
      if (_t.new_car.name === '') {
        _t.new_car_required_error();return;
      }
      if (_t.new_car.size === '') {
        _t.new_car_required_error();return;
      }
      if (_t.new_car.car_type === '') {
        _t.new_car_required_error();return;
      }
      if (_t.new_car.number === '0') {
        _t.new_car_required_error();return;
      }

      _t.data_loading = true;
      var form = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({ method: 'admin_add_car', params: { new_car: _t.new_car } });
      window.$.post(window.gw + 'api/car', { data: form }, function (r) {
        var d = JSON.parse(r);
        if (d.result === 'ok') {
          _t.data_loading = false;
          _t.$toast.open({
            duration: 1000,
            message: 'Готово!',
            position: 'is-top',
            type: 'is-success'
          });
          _t.reset_new_form();
          _t.fetch_data();
        }
      });

      return;
    },
    new_car_required_error: function new_car_required_error() {
      this.$toast.open({
        duration: 2000,
        message: 'Заполните все поля, номер карты так же необходим',
        position: 'is-bottom',
        type: 'is-danger'
      });
    },
    ws_on_message: function ws_on_message(message) {
      message = JSON.parse(message);
      var method = message.method;
      var params = message.params;
      if (method === 'reader_read') this.reader_read(params);
    },
    reader_read: function reader_read(params) {
      var cnumber = params.card_number;
      this.reader_target.number = cnumber;
      this.is_waiting_for_card = false;
      this.reader_target = null;
      console.log(cnumber);
    },
    reset_new_form: function reset_new_form() {
      this.new_car = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.empty_new_car));
    }

  }
});

/***/ }),

/***/ "ETia":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Cars_vue__ = __webpack_require__("E1qT");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0bddc49e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Cars_vue__ = __webpack_require__("Ll0H");
function injectStyle (ssrContext) {
  __webpack_require__("2fz6")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0bddc49e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Cars_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0bddc49e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Cars_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Fi4I":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      stream: '',
      source: '',
      canvas: null
    };
  },

  props: {
    width: {
      type: Number,
      default: 500
    },
    height: {
      type: Number,
      default: 500
    },
    autoplay: {
      type: Boolean,
      default: true
    },
    screenshotFormat: {
      type: String,
      default: 'image/jpeg'
    }
  },
  mounted: function mounted() {
    var _this = this;

    if (!this.hasMedia()) {
      this.$emit('notsupported');
      return;
    }

    this.requestMedia();

    if (navigator.getUserMedia) {
      navigator.getUserMedia({ video: { width: 1280, height: 720 } }, function (stream) {
        // this.source = window.URL.createObjectURL(stream)
        // this.source = stream
        _this.$refs.video.srcObject = stream;
        _this.stream = stream;
        _this.$emit('started', stream);
      }, function (error) {
        _this.$emit('error', error);
      });
    }
  },

  methods: {
    hasMedia: function hasMedia() {
      return !!this.getMedia();
    },
    getMedia: function getMedia() {
      return navigator.getUserMedia || navigator.webkitGetUserMedia || navigator.mozGetUserMedia || navigator.msGetUserMedia || navigator.oGetUserMedia;
    },
    requestMedia: function requestMedia() {
      navigator.getUserMedia = this.getMedia();
    },
    capture: function capture() {
      if (!this.hasMedia()) {
        this.$emit('notsupported');
        return null;
      }
      return this.getCanvas().toDataURL(this.screenshotFormat);
    },
    getCanvas: function getCanvas() {
      var video = this.$refs.video;
      if (!this.ctx) {
        var _canvas = document.createElement('canvas');
        // canvas.height = video.clientHeight
        // canvas.width = video.clientWidth
        _canvas.width = 1280;
        _canvas.height = 720;
        this.canvas = _canvas;

        this.ctx = _canvas.getContext('2d');
      }

      var ctx = this.ctx,
          canvas = this.canvas;

      ctx.drawImage(video, 0, 0, canvas.width, canvas.height);

      return canvas;
    }
  }
});

/***/ }),

/***/ "ISiE":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Iw1g":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Emitter__ = __webpack_require__("BDuk");





var _class = function () {
  function _class(Vue, connectionUrl) {
    var opts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, _class);

    this.format = opts.format && opts.format.toLowerCase();
    this.connectionUrl = connectionUrl;
    this.opts = opts;

    this.Vue = Vue;

    this.reconnection = this.opts.reconnection || false;
    this.reconnectionAttempts = this.opts.reconnectionAttempts || Infinity;
    this.reconnectionDelay = this.opts.reconnectionDelay || 1000;
    this.reconnectTimeoutId = 0;
    this.reconnectionCount = 0;

    this.connect(connectionUrl, opts);

    if (opts.store) {
      this.store = opts.store;
    }
    this.onEvent();
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(_class, [{
    key: 'connect',
    value: function connect(connectionUrl) {
      var _this = this;

      var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var protocol = opts.protocol || '';
      this.WebSocket = opts.WebSocket || (protocol === '' ? new WebSocket(connectionUrl) : new WebSocket(connectionUrl, protocol));
      if (this.format === 'json') {
        if (!('sendObj' in this.WebSocket)) {
          this.WebSocket.sendObj = function (obj) {
            return _this.WebSocket.send(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(obj));
          };
        }
      }

      this.Vue.prototype.$socket = this.WebSocket;

      return this.WebSocket;
    }
  }, {
    key: 'reconnect',
    value: function reconnect() {
      var _this2 = this;

      if (this.reconnectionCount <= this.reconnectionAttempts) {
        this.reconnectionCount++;
        clearTimeout(this.reconnectTimeoutId);

        this.reconnectTimeoutId = setTimeout(function () {
          if (_this2.store) {
            _this2.passToStore('SOCKET_RECONNECT', _this2.reconnectionCount);
          }

          _this2.connect(_this2.connectionUrl, _this2.opts);
          _this2.onEvent();
        }, this.reconnectionDelay);
      } else {
        if (this.store) {
          this.passToStore('SOCKET_RECONNECT_ERROR', true);
        }
      }
    }
  }, {
    key: 'onEvent',
    value: function onEvent() {
      var _this3 = this;

      ['onmessage', 'onclose', 'onerror', 'onopen'].forEach(function (eventType) {
        _this3.WebSocket[eventType] = function (event) {
          __WEBPACK_IMPORTED_MODULE_3__Emitter__["a" /* default */].emit(eventType, event);

          if (_this3.store) {
            _this3.passToStore('SOCKET_' + eventType, event);
          }

          if (_this3.reconnection && _this3.eventType === 'onopen') {
            _this3.reconnectionCount = 0;
          }

          if (_this3.reconnection && eventType === 'onclose') {
            _this3.reconnect(event);
          }

          if (_this3.reconnection && eventType === 'onerror') {
            _this3.reconnect(event);
          }
        };
      });
    }
  }, {
    key: 'passToStore',
    value: function passToStore(eventName, event) {
      if (!eventName.startsWith('SOCKET_')) {
        return;
      }
      var method = 'commit';
      var target = eventName.toUpperCase();
      var msg = event;
      if (this.format === 'json' && event.data) {
        msg = JSON.parse(event.data);
        if (msg.mutation) {
          target = [msg.namespace || '', msg.mutation].filter(function (e) {
            return !!e;
          }).join('/');
        } else if (msg.action) {
          method = 'dispatch';
          target = [msg.namespace || '', msg.action].filter(function (e) {
            return !!e;
          }).join('/');
        }
      }
      this.store[method](target, msg);
    }
  }]);

  return _class;
}();

/* harmony default export */ __webpack_exports__["a"] = (_class);

/***/ }),

/***/ "Ll0H":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"devices is-margin-top"},[_c('section',[_c('div',{staticClass:"container"},[_c('nav',{staticClass:"breadcrumb",attrs:{"aria-label":"breadcrumbs"}},[_c('ul',[_c('li',{staticClass:"is-active"},[_c('button',{staticClass:"button",attrs:{"id":"refresh_button"},on:{"click":function($event){_vm.fetch_data()}}},[_c('b-icon',{attrs:{"icon":"refresh"}})],1),_vm._v(" "),_c('a',{attrs:{"href":"#/tests","aria-current":"page"}},[_vm._v("  Список Машин")])])])]),_vm._v(" "),_c('b-tabs',{attrs:{"animated":false},model:{value:(_vm.activeTab),callback:function ($$v) {_vm.activeTab=$$v},expression:"activeTab"}},[_c('b-tab-item',{attrs:{"label":"Список"}},[_c('div',{staticClass:"columns is-margin-top"},[_c('div',{staticClass:"column is-two-thirds"},[_c('b-table',{attrs:{"data":_vm.cars,"selected":_vm.selected_car,"loading":_vm.data_loading,"paginated":""},on:{"update:selected":function($event){_vm.selected_car=$event}},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('b-table-column',{attrs:{"field":"name","label":"Название","width":"100","sortable":""}},[_vm._v("\n                    "+_vm._s(props.row.name)+"\n                  ")]),_vm._v(" "),_c('b-table-column',{attrs:{"field":"car_type","label":"Тип","width":"120","sortable":""}},[_vm._v("\n                    "+_vm._s(_vm.dict_car_type[props.row.car_type])+"\n                  ")]),_vm._v(" "),_c('b-table-column',{attrs:{"field":"size","label":"Размер","width":"150","sortable":""}},[_vm._v("\n                    "+_vm._s(_vm.dict_car_size[props.row.size])+"\n                  ")]),_vm._v(" "),_c('b-table-column',{attrs:{"field":"number","label":"Номер","width":"200","sortable":"","number":""}},[_vm._v("\n                    "+_vm._s(props.row.number)+"\n                  ")]),_vm._v(" "),_c('b-table-column',{attrs:{"field":"active","label":"Активна","width":"80","sortable":"","boolean":""}},[_c('b-checkbox',{attrs:{"disabled":""},model:{value:(props.row.active),callback:function ($$v) {_vm.$set(props.row, "active", $$v)},expression:"props.row.active"}})],1)]}}])})],1),_vm._v(" "),_c('div',{staticClass:"column is-one-third"},[_c('section',{staticClass:"is-margin-top box fast_edit"},[(_vm.selected_car.hasOwnProperty("_id"))?_c('b-tabs',{staticClass:"block",attrs:{"animated":false}},[_c('b-tab-item',{attrs:{"label":"Основные"}},[_c('b-field',{attrs:{"label":"Название"}},[_c('b-input',{model:{value:(_vm.selected_car.name),callback:function ($$v) {_vm.$set(_vm.selected_car, "name", $$v)},expression:"selected_car.name"}})],1),_vm._v(" "),_c('b-field',{attrs:{"label":"Тип машины"}},[_c('b-select',{attrs:{"expanded":"","placeholder":"Выберите тип машины"},model:{value:(_vm.selected_car.car_type),callback:function ($$v) {_vm.$set(_vm.selected_car, "car_type", $$v)},expression:"selected_car.car_type"}},_vm._l((_vm.car_types),function(option){return _c('option',{key:option.value,domProps:{"value":option.value}},[_vm._v("\n                            "+_vm._s(option.label)+"\n                        ")])}))],1),_vm._v(" "),_c('b-field',{attrs:{"label":"Размер машины"}},[_c('b-select',{attrs:{"expanded":"","placeholder":"Выберите размер машины"},model:{value:(_vm.selected_car.size),callback:function ($$v) {_vm.$set(_vm.selected_car, "size", $$v)},expression:"selected_car.size"}},_vm._l((_vm.car_sizes),function(option){return _c('option',{key:option.value,domProps:{"value":option.value}},[_vm._v("\n                            "+_vm._s(option.label)+"\n                        ")])}))],1),_vm._v(" "),_c('b-field',{attrs:{"label":"Активна?"}},[_c('b-switch',{model:{value:(_vm.selected_car.active),callback:function ($$v) {_vm.$set(_vm.selected_car, "active", $$v)},expression:"selected_car.active"}})],1)],1),_vm._v(" "),_c('b-tab-item',{attrs:{"label":"Номер"}},[_c('div',{staticClass:"card"},[_c('header',{staticClass:"card-header"},[_c('p',{staticClass:"card-header-title"},[_vm._v("\n                            Карта\n                          ")])]),_vm._v(" "),_c('div',{staticClass:"card-content"},[(_vm.selected_car.number === "0")?_c('div',[_vm._v("\n                            Карта не привязана\n                          ")]):_c('div',[_vm._v("\n                            Номер карты: "+_vm._s(_vm.selected_car.number)+"\n                          ")])]),_vm._v(" "),_c('footer',{staticClass:"card-footer"},[_c('a',{staticClass:"card-footer-item",on:{"click":function($event){_vm.is_waiting_for_card=true;_vm.reader_target=_vm.selected_car}}},[_vm._v("Перепривязать карту")])])])]),_vm._v(" "),_c('b-tab-item',{attrs:{"label":"Статус"}},[_vm._v("\n                    "+_vm._s(_vm.selected_car.state)+"\n                  ")]),_vm._v(" "),_c('button',{staticClass:"button is-margin-top",on:{"click":_vm.save_car}},[_vm._v("Сохранить")])],1):_c('div',{staticClass:"is-margin-top notification"},[_vm._v("\n                  Выберите устройство для быстрого редактирования.\n                ")])],1)])])]),_vm._v(" "),_c('b-tab-item',{attrs:{"label":"+ Добавить"}},[_c('div',{staticClass:"columns"},[_c('div',{staticClass:"column"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content"},[_c('b-field',{attrs:{"label":"Название"}},[_c('b-input',{model:{value:(_vm.new_car.name),callback:function ($$v) {_vm.$set(_vm.new_car, "name", $$v)},expression:"new_car.name"}})],1),_vm._v(" "),_c('b-field',{attrs:{"label":"Тип машины"}},[_c('b-select',{attrs:{"expanded":"","placeholder":"Выберите тип машины"},model:{value:(_vm.new_car.car_type),callback:function ($$v) {_vm.$set(_vm.new_car, "car_type", $$v)},expression:"new_car.car_type"}},_vm._l((_vm.car_types),function(option){return _c('option',{key:option.value,domProps:{"value":option.value}},[_vm._v("\n                          "+_vm._s(option.label)+"\n                      ")])}))],1),_vm._v(" "),_c('b-field',{attrs:{"label":"Размер машины"}},[_c('b-select',{attrs:{"expanded":"","placeholder":"Выберите размер машины"},model:{value:(_vm.new_car.size),callback:function ($$v) {_vm.$set(_vm.new_car, "size", $$v)},expression:"new_car.size"}},_vm._l((_vm.car_sizes),function(option){return _c('option',{key:option.value,domProps:{"value":option.value}},[_vm._v("\n                          "+_vm._s(option.label)+"\n                      ")])}))],1),_vm._v(" "),_c('b-field',{attrs:{"label":"Аквивна?"}},[_c('b-switch',{model:{value:(_vm.new_car.active),callback:function ($$v) {_vm.$set(_vm.new_car, "active", $$v)},expression:"new_car.active"}})],1)],1)])]),_vm._v(" "),_c('div',{staticClass:"column"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"content"},[(_vm.new_car.number === "0")?_c('div',{staticClass:"notification"},[_vm._v("\n                        Карта не привязана\n                      ")]):_c('div',{staticClass:"notification"},[_vm._v("\n                        Номер: "+_vm._s(_vm.new_car.number)+"\n                      ")]),_vm._v(" "),_c('button',{staticClass:"button",on:{"click":function($event){_vm.is_waiting_for_card=true;_vm.reader_target=_vm.new_car}}},[_vm._v("Привязать карту")])])])])]),_vm._v(" "),_c('div',{staticClass:"column"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"is-margin-bottom"},[_c('button',{staticClass:"button",on:{"click":_vm.add_car}},[_vm._v("Сохранить")])]),_vm._v(" "),_c('div',[_c('button',{staticClass:"button",on:{"click":_vm.reset_new_form}},[_vm._v("Сбросить форму")])])])])])])])],1)],1)]),_vm._v(" "),_c('b-modal',{attrs:{"active":_vm.is_waiting_for_card,"width":320,"scroll":"keep"},on:{"update:active":function($event){_vm.is_waiting_for_card=$event}}},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content text-center"},[_c('div',{staticClass:"is-margin-bottom"},[_c('img',{attrs:{"src":"static/images/icons8-foul-64.png"}})]),_vm._v(" "),_c('div',{staticClass:"is-margin-bottom"},[_vm._v("\n          Приложите карту к считывателю\n        ")])]),_vm._v(" "),(_vm.store.state.debug)?_c('footer',{staticClass:"card-footer"},[_c('a',{staticClass:"card-footer-item",on:{"click":function($event){_vm.reader_read({ card_number: String(Math.floor(Math.random()*100000000000)) })}}},[_vm._v("Случайный номер")]),_vm._v(" "),_c('a',{staticClass:"card-footer-item",on:{"click":function($event){_vm.reader_read({ card_number: "80000000001" })}}},[_vm._v("Карта 1")]),_vm._v(" "),_c('a',{staticClass:"card-footer-item",on:{"click":function($event){_vm.reader_read({ card_number: "80000000002" })}}},[_vm._v("Карта 2")]),_vm._v(" "),_c('a',{staticClass:"card-footer-item",on:{"click":function($event){_vm.reader_read({ card_number: "80000000003" })}}},[_vm._v("Карта 3")])]):_vm._e()])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b48df06c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("DFBn");
function injectStyle (ssrContext) {
  __webpack_require__("xX1n")
  __webpack_require__("ug3k")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b48df06c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "MVbf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[(_vm.files.length >= 2)?_c('div',[_c('b-collapse',{staticClass:"card",attrs:{"open":_vm.isOpen},on:{"update:open":function($event){_vm.isOpen=$event}}},[_c('div',{staticClass:"card-header",attrs:{"slot":"trigger"},slot:"trigger"},[_c('p',{staticClass:"card-header-title"},[_c('b-icon',{attrs:{"icon":"folder-multiple-image"}}),_vm._v("    "+_vm._s(_vm.label)+"\n            ")],1),_vm._v(" "),_c('a',{staticClass:"card-header-icon"},[_c('b-icon',{attrs:{"icon":_vm.isOpen ?
                    'menu-down' : 'menu-up'}})],1)]),_vm._v(" "),_c('div',{staticClass:"card-content"},[(_vm.files.indexOf("audio") >= 0)?_c('b-field',{attrs:{"label":"Звук"}},[(_vm.progress.audio.loading)?_c('div',[_c('b-field',{staticClass:"notification",attrs:{"label":"Загрузка"}},[_c('n3-progress',{staticClass:"margin"},[_c('n3-progressbar',{attrs:{"now":_vm.progress.audio.p,"type":"success","height":"10px"}})],1)],1)],1):_c('div',[(_vm.value.audio.name === "")?_c('b-field',[_c('b-upload',{staticClass:"is-full-width",attrs:{"drag-drop":""},on:{"input":_vm.audio_input},model:{value:(_vm.audio_file),callback:function ($$v) {_vm.audio_file=$$v},expression:"audio_file"}},[_c('div',{staticClass:"content has-text-centered"},[_c('b-icon',{attrs:{"icon":"upload"}}),_vm._v(" Перетащите файл сюда.\n                  ")],1)])],1):_c('b-field',[_c('b-notification',{on:{"close":_vm.delete_audio}},[_c('button',{on:{"click":function($event){_vm.preview_audio(_vm.value.audio.filename)}}},[_c('b-icon',{attrs:{"icon":"presentation-play","size":"is_small"}})],1),_vm._v("    "+_vm._s(_vm.value.audio.name)+"\n                ")])],1)],1)]):_vm._e(),_vm._v(" "),(_vm.files.indexOf("image") >= 0)?_c('b-field',{attrs:{"label":"Картинка"}},[(_vm.progress.image.loading)?_c('div',[_c('b-field',{staticClass:"notification",attrs:{"label":"Загрузка"}},[_c('n3-progress',{staticClass:"margin"},[_c('n3-progressbar',{attrs:{"now":_vm.progress.image.p,"type":"success","height":"10px"}})],1)],1)],1):_c('div',[(_vm.value.image.name === "")?_c('b-field',[_c('b-upload',{staticClass:"is-full-width",attrs:{"drag-drop":""},on:{"input":_vm.image_input},model:{value:(_vm.image_file),callback:function ($$v) {_vm.image_file=$$v},expression:"image_file"}},[_c('div',{staticClass:"content has-text-centered"},[_c('b-icon',{attrs:{"icon":"upload"}}),_vm._v(" Перетащите файл сюда.\n                  ")],1)])],1):_c('b-field',[_c('b-notification',{on:{"close":_vm.delete_image}},[_c('button',{on:{"click":function($event){_vm.preview_image(_vm.value.image.filename)}}},[_c('b-icon',{attrs:{"icon":"presentation-play","size":"is_small"}})],1),_vm._v("    "+_vm._s(_vm.value.image.name)+"\n                ")])],1)],1)]):_vm._e(),_vm._v(" "),(_vm.files.indexOf("video") >= 0)?_c('b-field',{attrs:{"label":"Видео"}},[(_vm.progress.video.loading)?_c('div',[_c('b-field',{staticClass:"notification",attrs:{"label":"Загрузка"}},[_c('n3-progress',{staticClass:"margin"},[_c('n3-progressbar',{attrs:{"now":_vm.progress.video.p,"type":"success","height":"10px"}})],1)],1)],1):_c('div',[(_vm.value.video.name === "")?_c('b-field',[_c('b-upload',{staticClass:"is-full-width",attrs:{"drag-drop":""},on:{"input":_vm.video_input},model:{value:(_vm.video_file),callback:function ($$v) {_vm.video_file=$$v},expression:"video_file"}},[_c('div',{staticClass:"content has-text-centered"},[_c('b-icon',{attrs:{"icon":"upload"}}),_vm._v(" Перетащите файл сюда.\n                  ")],1)])],1):_c('b-field',[_c('b-notification',{on:{"close":_vm.delete_video}},[_c('button',{on:{"click":function($event){_vm.preview_video(_vm.value.video.filename)}}},[_c('b-icon',{attrs:{"icon":"presentation-play","size":"is_small"}})],1),_vm._v("    "+_vm._s(_vm.value.video.name)+"\n                ")])],1)],1)]):_vm._e()],1)])],1):_vm._e(),_vm._v(" "),(_vm.files.length === 1)?_c('div',[(_vm.files.indexOf("audio") >= 0)?_c('b-field',{attrs:{"label":_vm.label}},[(_vm.value.audio.name === "")?_c('b-field',[_c('b-upload',{staticClass:"is-full-width",attrs:{"drag-drop":""},on:{"input":_vm.audio_input},model:{value:(_vm.audio_file),callback:function ($$v) {_vm.audio_file=$$v},expression:"audio_file"}},[_c('div',{staticClass:"content has-text-centered"},[_c('b-icon',{attrs:{"icon":"upload"}}),_vm._v(" Перетащите файл сюда.\n          ")],1)])],1):_c('b-field',[_c('b-notification',{on:{"close":_vm.delete_audio}},[_vm._v("\n          "+_vm._s(_vm.value.audio.name)+"\n        ")])],1)],1):_vm._e(),_vm._v(" "),(_vm.files.indexOf("image") >= 0)?_c('b-field',{attrs:{"label":_vm.label}},[(_vm.value.image.name === "")?_c('b-field',[_c('b-upload',{staticClass:"is-full-width",attrs:{"drag-drop":""},on:{"input":_vm.image_input},model:{value:(_vm.image_file),callback:function ($$v) {_vm.image_file=$$v},expression:"image_file"}},[_c('div',{staticClass:"content has-text-centered"},[_c('b-icon',{attrs:{"icon":"upload"}}),_vm._v(" Перетащите файл сюда.\n          ")],1)])],1):_c('b-field',[_c('b-notification',{on:{"close":_vm.delete_image}},[_vm._v("\n          "+_vm._s(_vm.value.image.name)+"\n        ")])],1)],1):_vm._e(),_vm._v(" "),(_vm.files.indexOf("video") >= 0)?_c('b-field',{attrs:{"label":_vm.label}},[(_vm.value.video.name === "")?_c('b-field',[_c('b-upload',{staticClass:"is-full-width",attrs:{"drag-drop":""},on:{"input":_vm.video_input},model:{value:(_vm.video_file),callback:function ($$v) {_vm.video_file=$$v},expression:"video_file"}},[_c('div',{staticClass:"content has-text-centered"},[_c('b-icon',{attrs:{"icon":"upload"}}),_vm._v(" Перетащите файл сюда.\n          ")],1)])],1):_c('b-field',[_c('b-notification',{on:{"close":_vm.delete_video}},[_vm._v("\n          "+_vm._s(_vm.value.video.name)+"\n        ")])],1)],1):_vm._e()],1):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Me6I":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MediaContainer_vue__ = __webpack_require__("QCUF");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_14a9540e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MediaContainer_vue__ = __webpack_require__("MVbf");
function injectStyle (ssrContext) {
  __webpack_require__("P6UF")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-14a9540e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MediaContainer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_14a9540e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MediaContainer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_websocket_Main__ = __webpack_require__("xB9i");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_vue2_frappe__ = __webpack_require__("No2i");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store__ = __webpack_require__("olkN");
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.








__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_5__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_4__App__["a" /* default */] }
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3__components_vue2_frappe__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2__components_websocket_Main__["a" /* default */], window.wsgw, {
  reconnection: true, // (Boolean) whether to reconnect automatically (false)
  reconnectionDelay: 3000, // (Number) how long to initially wait before attempting a new (1000)
  secure: false,
  store: __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */]
});

/***/ }),

/***/ "No2i":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Charts__ = __webpack_require__("54CK");


/* harmony default export */ __webpack_exports__["a"] = ({
    install: function install(Vue, options) {
        Vue.component('vue-frappe', __WEBPACK_IMPORTED_MODULE_0__components_Charts__["a" /* Chart */]);
    }
});

/***/ }),

/***/ "Nva0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['username'],
  data: function data() {
    this.username = this.$parent.$parent.selected_user.username; // dirty hack, replace later
    this.fetch_data();
    return {
      log: []
    };
  },
  methods: {
    fetch_data: function fetch_data() {
      var _this = this;
      var form = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({ method: 'admin_get_user_finance_history', params: { username: _this.username } });
      window.$.post(window.gw + 'api/finance', { data: form }, function (r) {
        var d = JSON.parse(r);
        if (d.result === 'ok') {
          // ok
          _this.log = d.params.history;
        } else {
          // error
        }
      });
    }
  }
});

/***/ }),

/***/ "OKwd":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "P+oJ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "P6UF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "QCUF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'mediaUploader',
  props: {
    label: String,
    value: {
      type: Object,
      default: function _default() {
        return this.empty_media;
      }
    },
    files: {
      type: Array,
      default: function _default() {
        return ['audio', 'image', 'video'];
      }
    },
    disabled: Boolean
  },
  data: function data() {
    return {
      audio_file: [],
      image_file: [],
      video_file: [],
      progress: { 'audio': { loading: false, p: 0 }, 'image': { loading: false, p: 0 }, 'video': { loading: false, p: 0 } },
      empty_file: { name: '', filename: '', filetype: '', filesize: 0 },
      empty_media: { audio: { name: '', filename: '', filetype: '', filesize: 0 }, video: { name: '', filename: '', filetype: '', filesize: 0 }, image: { name: '', filename: '', filetype: '', filesize: 0 } },
      isOpen: false
    };
  },
  methods: {
    audio_input: function audio_input(str) {
      // console.log(str, this.audio_file, this.value)
      // this.value.audio.name = this.audio_file[0].name
      // this.$emit('input', this.value)
      this.upload(this.audio_file[0], 'audio');
    },
    image_input: function image_input(str) {
      // console.log(str, this.image_file, this.value)
      // this.value.image.name = this.image_file[0].name
      // this.$emit('input', this.value)
      this.upload(this.image_file[0], 'image');
    },
    video_input: function video_input(str) {
      // console.log(str, this.video_file, this.value)
      // this.value.video.name = this.video_file[0].name
      // this.$emit('input', this.value)
      this.upload(this.video_file[0], 'video');
    },
    delete_audio: function delete_audio() {
      this.value.audio = this.empty_file;
      this.$emit('input', this.value);
    },
    delete_image: function delete_image() {
      this.value.image = this.empty_file;
      this.$emit('input', this.value);
    },
    delete_video: function delete_video() {
      this.value.video = this.empty_file;
      this.$emit('input', this.value);
    },
    upload: function upload(file, type) {
      var _this = this;
      var xhr = new XMLHttpRequest();
      _this.progress[type].p = 0;
      _this.progress[type].loading = true;
      xhr.open('PUT', window.gw + 'api/upload/' + file.name, true);
      xhr.setRequestHeader('Content-Type', file.type);
      xhr.setRequestHeader('Content-Range', 'bytes 0-' + (file.size - 1) + '/' + file.size);
      console.log('template', 'bytes 0-' + (file.size - 1) + '/' + file.size, file);

      if (xhr.upload) {
        xhr.upload.addEventListener('progress', function (e) {
          var percent = e.loaded / e.total * 100;
          var p = parseFloat(percent).toFixed(0);
          _this.progress[type].p = p;
        });
      }

      xhr.onload = function (e) {
        console.log('upload complete', e);
        var d = JSON.parse(e.currentTarget.response);
        if (d.result === 'ok') {
          var f = d.params.file;
          _this.value[type].name = f.real_filename;
          _this.value[type].filename = f.filename;
          _this.value[type].filesize = f.filesize;
          _this.value[type].filetype = f.filetype;
          _this.$emit('input', _this.value);
          console.log(_this.value);
        }
        _this.progress[type].loading = false;
      };
      xhr.onerror = function (e) {
        console.log('upload error', e);
        _this.progress[type].loading = false;
      };
      xhr.send(file);
    }, // upload
    preview_image: function preview_image(img) {
      img = '/uploads/' + img;
      this.$modal.open('<p class="image"><img src="' + img + '" volume="0.2" /></p>');
    },
    preview_audio: function preview_audio(audio) {
      audio = '/uploads/' + audio;
      this.$modal.open('<p><audio controls><source src="' + audio + '" volume="0.2" /></audio></p>');
    },
    preview_video: function preview_video(video) {
      video = '/uploads/' + video;
      this.$modal.open('<p><video controls><source src="' + video + '" volume="0.2" /></audio></p>');
    }
  },
  watch: {
    value: function value(_value) {
      this.value = _value;
      console.log('value', _value);
    },
    newValue: function newValue(value) {
      if (value === this.value) {
        this.$emit('input', value);
        console.log('new_value', value);
      }
    }
  }
});

/***/ }),

/***/ "QhQe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('video',{ref:"video",attrs:{"width":this.width,"height":this.height,"srcObject":this.source,"autoplay":this.autoplay}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "RJ9I":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FinanceLog_vue__ = __webpack_require__("Nva0");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c082df16_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FinanceLog_vue__ = __webpack_require__("cYlJ");
function injectStyle (ssrContext) {
  __webpack_require__("YKz7")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-c082df16"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FinanceLog_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c082df16_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FinanceLog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "RykC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Tests_vue__ = __webpack_require__("libW");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2c0c7be2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Tests_vue__ = __webpack_require__("3j2k");
function injectStyle (ssrContext) {
  __webpack_require__("pP30")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2c0c7be2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Tests_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2c0c7be2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Tests_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "SxFe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Devices_vue__ = __webpack_require__("hi9z");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_026bc358_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Devices_vue__ = __webpack_require__("p/gC");
function injectStyle (ssrContext) {
  __webpack_require__("P+oJ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-026bc358"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Devices_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_026bc358_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Devices_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "TKn+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Users_vue__ = __webpack_require__("dxC/");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_27204267_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Users_vue__ = __webpack_require__("Zv5e");
function injectStyle (ssrContext) {
  __webpack_require__("lWtS")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-27204267"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Users_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_27204267_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Users_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "UOFx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins__ = __webpack_require__("6aAP");
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins__["a" /* mixin */]]
});

/***/ }),

/***/ "US8T":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MainPage_vue__ = __webpack_require__("14xJ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4df93cbc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MainPage_vue__ = __webpack_require__("5DNF");
function injectStyle (ssrContext) {
  __webpack_require__("OKwd")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4df93cbc"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MainPage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4df93cbc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MainPage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Woqv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'stats',
  data: function data() {
    this.$parent.active_tab = 'stats';
    return {
      state: 'idle',
      barOptions: { height: 12, depth: 3 },
      date_from: new Date(),
      date_due: new Date(),
      report_type: 'daily',
      reports: [],
      data_loading: false,
      data_ready: false,
      report_types: [{ type: 'daily', label: 'Ежедневный' }, { type: 'monthly', label: 'Ежемесячный' }, { type: 'aggregated', label: 'Общий' }],
      activeTab: 0,
      empty_charts_data: {
        labels: [],
        new_users: { name: 'Новые', chartType: 'bar', values: [] },
        returning_users: { name: 'Рекуррентные', chartType: 'bar', values: [] },
        earnings: { name: 'Заработано', chartType: 'bar', values: [] },
        spendings: { name: 'Потрачено', chartType: 'bar', values: [] },
        test_tries: { name: 'Попыток', chartType: 'bar', values: [] },
        test_passed: { name: 'Пройдено', chartType: 'bar', values: [] },
        vgm_rents: { name: 'Игровые автом.', chartType: 'bar', values: [] },
        vgm_spendings: { name: 'Игровые автом.', chartType: 'bar', values: [] },
        car_electro_rents: { name: 'Электрокар', chartType: 'bar', values: [] },
        car_electro_spendings: { name: 'Электрокар', chartType: 'bar', values: [] },
        car_manual_rents: { name: 'Педали', chartType: 'bar', values: [] },
        car_manual_spendings: { name: 'Педали', chartType: 'bar', values: [] }
      },
      aggregated_chart: {},
      empty_aggregated_chart: {
        users: {
          labels: ['Новых', 'Рекуррентных'],
          new_users: { name: 'Новые', chartType: 'bar', values: [0, 0] },
          returning_users: { name: 'Рекуррентные', chartType: 'bar', values: [0, 0] }
        },
        tests: {
          labels: ['Пройдено', 'Не пройдено'],
          tries: { name: 'Попыток', chartType: 'bar', values: [0, 0] },
          passed: { name: 'Пройдено', chartType: 'bar', values: [0, 0] },
          tests: []
        },
        cars: {},
        vgms: {
          labels: [],
          data: []
        }
      },
      charts_data: {}
    };
  },

  methods: {
    show_reports: function show_reports() {
      console.log(this.report_type, this.date_from.getTime(), this.date_due.getTime());
      var t = this;
      t.data_loading = true;
      t.data_ready = false;
      t.state = 'idle';
      var form = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()({ method: 'admin_get_reports', params: { report_type: this.report_type, date_from: this.date_from.getTime(), date_due: this.date_due.getTime() } });
      window.$.post(window.gw + 'api/statistics', { data: form }, function (r) {
        var d = JSON.parse(r);
        if (d.result === 'ok') {
          t.reports = d.params.reports;
          console.log(t.reports);
          t.prepare_charts_data();
        }
      });
    },
    prepare_charts_data: function prepare_charts_data() {
      var t = this;
      t.data_loading = false;
      console.log(t.reports[0].report_type);
      if (t.reports[0].report_type !== 'aggregated') {
        t.charts_data = JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(t.empty_charts_data));
        t.reports.forEach(function (report) {
          var date = new Date(report.date);
          t.charts_data.labels.push(date.toLocaleDateString());
          t.charts_data.new_users.values.push(report.report.new_users);
          t.charts_data.returning_users.values.push(report.report.returning_users);

          t.charts_data.earnings.values.push(report.report.total_earnings);
          t.charts_data.spendings.values.push(report.report.total_spendings);

          t.charts_data.test_tries.values.push(report.report.tests.tries);
          t.charts_data.test_passed.values.push(report.report.tests.passed);

          t.charts_data.vgm_rents.values.push(report.report.vgms.rents);
          t.charts_data.vgm_spendings.values.push(report.report.vgms.spendings);

          t.charts_data.car_electro_rents.values.push(report.report.cars.electro.rents);
          t.charts_data.car_electro_spendings.values.push(report.report.cars.electro.spendings);

          t.charts_data.car_manual_rents.values.push(report.report.cars.electro.rents);
          t.charts_data.car_manual_spendings.values.push(report.report.cars.manual.spendings);
        });
        console.log(t.charts_data);
        t.data_ready = true;
        t.state = 'stats';
      }
      if (t.reports[0].report_type === 'aggregated') {
        var r = t.reports[0].report;
        t.aggregated_chart = JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(t.empty_aggregated_chart));
        var c = t.aggregated_chart;

        c.users.new_users.values = [r.new_users, r.returning_users];

        c.tests.tries.values = [r.tests.passed, r.tests.tries - r.tests.passed];

        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(r.tests.tests).map(function (key, id) {
          var test = { id: id, title: key, data: { name: key, chartType: 'bar', values: [r.tests.tests[key].passed, r.tests.tests[key].tries - r.tests.tests[key].passed] } };
          c.tests.tests.push(test);
          console.log(id);
        });

        c.vgms.rents = r.vgms.rents;
        c.vgms.spendings = r.vgms.spendings;

        c.cars.rents = r.cars.rents;
        c.cars.spendings = r.cars.spendings;

        c.spendings = { name: 'Затраты ладушек', values: [r.cars.spendings, r.vgms.spendings] };

        c.cars.car_types = { name: 'Затраты ладушек на машины', labels: ['Электро', 'Вело'], values: [r.cars.electro.spendings, r.cars.manual.spendings] };

        c.vgms.raw = r.vgms.vgms;

        t.data_ready = true;
        t.state = 'aggregated';
      }
    }
  }
});

/***/ }),

/***/ "X68B":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Photo_vue__ = __webpack_require__("7knd");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_684631e1_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Photo_vue__ = __webpack_require__("jgfr");
function injectStyle (ssrContext) {
  __webpack_require__("ISiE")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-684631e1"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Photo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_684631e1_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Photo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "YKz7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_dist_vue_esm_js__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_buefy__ = __webpack_require__("MMSg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_buefy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_buefy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_buefy_lib_buefy_css__ = __webpack_require__("doPI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_buefy_lib_buefy_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_buefy_lib_buefy_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_N3_components__ = __webpack_require__("1KMj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_N3_components___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_N3_components__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_N3_components_dist_index_min_css__ = __webpack_require__("vzL1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_N3_components_dist_index_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_N3_components_dist_index_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Stats__ = __webpack_require__("dY3R");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Users__ = __webpack_require__("TKn+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Tests__ = __webpack_require__("RykC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Devices__ = __webpack_require__("SxFe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Cars__ = __webpack_require__("ETia");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_MainPage__ = __webpack_require__("US8T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_MediaContainer__ = __webpack_require__("Me6I");







// custom components






// import Cafes from '@/components/Cafes'


__WEBPACK_IMPORTED_MODULE_0_vue_dist_vue_esm_js__["default"].component('media-uploader', __WEBPACK_IMPORTED_MODULE_12__components_MediaContainer__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_0_vue_dist_vue_esm_js__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_0_vue_dist_vue_esm_js__["default"].use(__WEBPACK_IMPORTED_MODULE_2_buefy___default.a, {
  defaultDayNames: ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'],
  defaultMonthNames: ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'],
  defaultFirstDayOfWeek: 1
  // defaultDateParser: function (date) {
  //   console.log('dafaultDateParser', date)
  //   var d = new Date(Date.parse(date))
  //   return d
  // }
});

__WEBPACK_IMPORTED_MODULE_0_vue_dist_vue_esm_js__["default"].use(__WEBPACK_IMPORTED_MODULE_4_N3_components___default.a, 'en');

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    name: 'Root',
    redirect: '/home'
  }, {
    path: '/users',
    name: 'Users',
    component: __WEBPACK_IMPORTED_MODULE_7__components_Users__["a" /* default */]
  }, {
    path: '/tests',
    name: 'Tests',
    component: __WEBPACK_IMPORTED_MODULE_8__components_Tests__["a" /* default */]
  }, {
    path: '/devices',
    name: 'Devices',
    component: __WEBPACK_IMPORTED_MODULE_9__components_Devices__["a" /* default */]
  }, {
    path: '/cars',
    name: 'Cars',
    component: __WEBPACK_IMPORTED_MODULE_10__components_Cars__["a" /* default */]
  }, {
    path: '/stats',
    name: 'Stats',
    component: __WEBPACK_IMPORTED_MODULE_6__components_Stats__["a" /* default */]
  }, {
    path: '/home',
    name: 'home',
    component: __WEBPACK_IMPORTED_MODULE_11__components_MainPage__["a" /* default */]
  }]
}));

/***/ }),

/***/ "Zv5e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"users is-margin-top"},[_c('section',[_c('div',{staticClass:"container"},[_c('b-tabs',{attrs:{"animated":false},model:{value:(_vm.active_tab),callback:function ($$v) {_vm.active_tab=$$v},expression:"active_tab"}},[_c('b-tab-item',{attrs:{"label":"Список"}},[_c('div',{staticClass:"columns is-margin-top"},[_c('div',{staticClass:"column is-two-thirds"},[_c('div',{staticClass:"field has-addons"},[_c('div',{staticClass:"control",staticStyle:{"width":"calc(100% - 20px)"}},[_c('b-input',{attrs:{"expanded":"","placeholder":"Поиск","type":"search","icon":"magnify"},model:{value:(_vm.search_string),callback:function ($$v) {_vm.search_string=$$v},expression:"search_string"}})],1),_vm._v(" "),_c('div',{staticClass:"control"},[_c('button',{staticClass:"button",on:{"click":function($event){_vm.search_string = ""}}},[_vm._v("X")])])]),_vm._v(" "),_c('b-table',{attrs:{"data":_vm.table_data,"paginated":true,"pagination-simple":true,"striped":true,"narrowed":true,"loading":_vm.data_loading,"selected":_vm.selected_user,"default-sort":"created","default-sort-direction":"desc"},on:{"update:selected":function($event){_vm.selected_user=$event}},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('b-table-column',{attrs:{"field":"username","label":"Имя пользователя","width":"220","sortable":""}},[_vm._v("\n                    "+_vm._s(props.row.username)+"\n                  ")]),_vm._v(" "),_c('b-table-column',{attrs:{"field":"fio","label":"ФИО","width":"200","sortable":""}},[_vm._v("\n                    "+_vm._s(props.row.fio)+"\n                  ")]),_vm._v(" "),_c('b-table-column',{attrs:{"field":"created","label":"Дата регистрации","width":"80","sortable":"","numeric":""}},[_vm._v("\n                      "+_vm._s(new Date(props.row.created).toLocaleDateString())+"\n                  ")]),_vm._v(" "),_c('b-table-column',{attrs:{"field":"phone","label":"Телефон","width":"140","sortable":""}},[_vm._v("\n                    "+_vm._s(props.row.phone)+"\n                  ")]),_vm._v(" "),_c('b-table-column',{attrs:{"field":"birthday","label":"Д.Р.","custom-sort":_vm.birthday_sort,"sortable":""}},[_vm._v("\n                    "+_vm._s(new Date(props.row.birthday).toLocaleDateString())+"\n                  ")]),_vm._v(" "),_c('b-table-column',{attrs:{"field":"activated","label":"Активирован","width":"80","sortable":"","boolean":""}},[_c('b-checkbox',{attrs:{"disabled":""},model:{value:(props.row.activated),callback:function ($$v) {_vm.$set(props.row, "activated", $$v)},expression:"props.row.activated"}})],1)]}}])})],1),_vm._v(" "),_c('div',{staticClass:"column is-one-thirds"},[_c('a',{staticClass:"button"},[_c('span',[_vm._v("Найти по карте")])]),_vm._v(" "),_c('section',{staticClass:"is-margin-top box fast_edit"},[(_vm.selected_user.hasOwnProperty("username"))?_c('div',[_c('b-tabs',{attrs:{"animated":false}},[_c('b-tab-item',{attrs:{"label":"Аккаунт"}},[_c('b-field',{staticClass:"is-margin-top",attrs:{"label":"Имя пользователя"}},[_c('b-input',{attrs:{"placeholder":"Имя пользователя"},model:{value:(_vm.selected_user.username),callback:function ($$v) {_vm.$set(_vm.selected_user, "username", $$v)},expression:"selected_user.username"}})],1),_vm._v(" "),_c('b-field',{attrs:{"label":"Телефон"}},[_c('b-input',{attrs:{"placeholder":"Телефон"},model:{value:(_vm.selected_user.phone),callback:function ($$v) {_vm.$set(_vm.selected_user, "phone", $$v)},expression:"selected_user.phone"}})],1),_vm._v(" "),_c('b-field',{attrs:{"label":"Пароль"}},[_c('b-input',{attrs:{"type":"password","placeholder":"Пароль","password-reveal":""},model:{value:(_vm.change_password),callback:function ($$v) {_vm.change_password=$$v},expression:"change_password"}})],1),_vm._v(" "),_c('b-field',{attrs:{"label":"Подтверждение пароля"}},[_c('b-input',{attrs:{"type":"password","placeholder":"Подтверждение пароля","password-reveal":""},model:{value:(_vm.change_confirm),callback:function ($$v) {_vm.change_confirm=$$v},expression:"change_confirm"}})],1),_vm._v(" "),_c('b-field',{attrs:{"label":"Роли"}},[_c('n3-select',{attrs:{"multiple":"","search":""},model:{value:(_vm.selected_user.roles),callback:function ($$v) {_vm.$set(_vm.selected_user, "roles", $$v)},expression:"selected_user.roles"}},_vm._l((_vm.roles),function(role){return _c('n3-option',{key:role,attrs:{"value":role}},[_vm._v(_vm._s(role))])}))],1),_vm._v(" "),_c('b-field',{attrs:{"label":"Дата регистрации"}},[_vm._v("\n                        "+_vm._s(new Date(_vm.selected_user.created).toLocaleDateString())+"\n                      ")]),_vm._v(" "),_c('b-field',{attrs:{"label":"Активирован"}},[_c('b-switch',{model:{value:(_vm.selected_user.activated),callback:function ($$v) {_vm.$set(_vm.selected_user, "activated", $$v)},expression:"selected_user.activated"}})],1),_vm._v(" "),_c('a',{staticClass:"button is-primary",on:{"click":function($event){_vm.fast_edit_save()}}},[_vm._v("Сохранить")])],1),_vm._v(" "),_c('b-tab-item',{attrs:{"label":"ФИО"}},[_c('photo',{model:{value:(_vm.selected_user.photo),callback:function ($$v) {_vm.$set(_vm.selected_user, "photo", $$v)},expression:"selected_user.photo"}}),_vm._v(" "),_c('b-field',{staticClass:"is-margin-top",attrs:{"label":"Ф.И.О."}},[_c('b-input',{attrs:{"placeholder":"ФИО"},model:{value:(_vm.selected_user.fio),callback:function ($$v) {_vm.$set(_vm.selected_user, "fio", $$v)},expression:"selected_user.fio"}})],1),_vm._v(" "),_c('b-field',{staticClass:"is-margin-top",attrs:{"label":"Дата рождения"}},[_c('b-datepicker',{attrs:{"placeholder":"Дата рождения","date-parser":_vm.date_parser},model:{value:(_vm.selected_user.birthday),callback:function ($$v) {_vm.$set(_vm.selected_user, "birthday", $$v)},expression:"selected_user.birthday"}})],1),_vm._v(" "),_c('b-field',{staticClass:"is-margin-top",attrs:{"label":"Документ"}},[_c('b-input',{attrs:{"placeholder":"Документ"},model:{value:(_vm.selected_user.document_number),callback:function ($$v) {_vm.$set(_vm.selected_user, "document_number", $$v)},expression:"selected_user.document_number"}})],1),_vm._v(" "),_c('b-field',{staticClass:"is-margin-top",attrs:{"label":"Учебное учереждение"}},[_c('b-input',{attrs:{"placeholder":"Учебное учереждение"},model:{value:(_vm.selected_user.school),callback:function ($$v) {_vm.$set(_vm.selected_user, "school", $$v)},expression:"selected_user.school"}})],1),_vm._v(" "),_c('b-field',{staticClass:"is-margin-top",attrs:{"label":"Представитель"}},[_c('b-input',{attrs:{"placeholder":"Представитель"},model:{value:(_vm.selected_user.representive),callback:function ($$v) {_vm.$set(_vm.selected_user, "representive", $$v)},expression:"selected_user.representive"}})],1),_vm._v(" "),_c('b-field',{staticClass:"is-margin-top",attrs:{"label":"Контакты представителя"}},[_c('b-input',{attrs:{"placeholder":"Контакты представителя"},model:{value:(_vm.selected_user.representive_contacts),callback:function ($$v) {_vm.$set(_vm.selected_user, "representive_contacts", $$v)},expression:"selected_user.representive_contacts"}})],1),_vm._v(" "),_c('a',{staticClass:"button is-primary",on:{"click":function($event){_vm.fast_edit_save()}}},[_vm._v("Сохранить")])],1),_vm._v(" "),_c('b-tab-item',{attrs:{"label":"Баланс"}},[_c('blockquote',[_c('h4',[_vm._v("Баланс: "+_vm._s(_vm.selected_user.balance))])]),_vm._v(" "),_c('button',{staticClass:"button is-light is-margin-top",staticStyle:{"margin-bottom":"10px"},on:{"click":function($event){_vm.open_finance_history()}}},[_vm._v("История")]),_vm._v(" "),_c('div',{staticClass:"notification"},[_c('b-field',{attrs:{"label":"Сумма"}},[_c('b-input',{attrs:{"type":"text","placeholder":"Сумма","icon":"currency-rub"},model:{value:(_vm.finance_new.summ),callback:function ($$v) {_vm.$set(_vm.finance_new, "summ", $$v)},expression:"finance_new.summ"}})],1),_vm._v(" "),_c('b-field',{attrs:{"label":"Операция"}},[_c('b-select',{attrs:{"placeholder":"Операция"},model:{value:(_vm.finance_new.action),callback:function ($$v) {_vm.$set(_vm.finance_new, "action", $$v)},expression:"finance_new.action"}},_vm._l((_vm.money_operation),function(option){return _c('option',{key:option.id,domProps:{"value":option.id}},[_vm._v("\n                                "+_vm._s(option.label)+"\n                              ")])}))],1),_vm._v(" "),_c('b-field',{attrs:{"label":"Описание"}},[_c('b-input',{attrs:{"type":"text","placeholder":"описание"},model:{value:(_vm.finance_new.comments),callback:function ($$v) {_vm.$set(_vm.finance_new, "comments", $$v)},expression:"finance_new.comments"}})],1),_vm._v(" "),_c('button',{staticClass:"button is-primary",attrs:{"disabled":!_vm.finance_new_ready},on:{"click":function($event){_vm.finance_execute()}}},[_vm._v("Применить")])],1)]),_vm._v(" "),_c('b-tab-item',{attrs:{"label":"Информация"}},[_c('div',{staticClass:"card"},[_c('header',{staticClass:"card-header"},[_c('p',{staticClass:"card-header-title"},[_vm._v("\n                            Карта\n                          ")])]),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"content"},[(_vm.selected_user.card_number === "0")?_c('div',{staticClass:"notification"},[_vm._v("\n                              Карта не привязана\n                            ")]):_c('div',{staticClass:"notification"},[_vm._v("\n                              Номер карты: "+_vm._s(_vm.selected_user.card_number)+"\n                            ")]),_vm._v(" "),_c('button',{staticClass:"button",on:{"click":function($event){_vm.is_waiting_for_card=true;_vm.reader_target=_vm.selected_user}}},[_vm._v("Привязать карту")])])])]),_vm._v(" "),_c('div',{staticClass:"card is-margin-top"},[_c('header',{staticClass:"card-header"},[_c('p',{staticClass:"card-header-title"},[_vm._v("\n                            Прогресс\n                          ")])]),_vm._v(" "),_c('div',{staticClass:"card-content"},[(_vm.selected_user.got_pdd === true)?_c('div',{staticClass:"notification"},[_vm._v("\n                            Тест на права пройден!\n                            "),_c('button',{staticClass:"button is-margin-top",on:{"click":_vm.take_pdd}},[_vm._v("Лишить прав")])]):_vm._e(),_vm._v(" "),(_vm.selected_user.got_pdd === false)?_c('div',{staticClass:"notification"},[_vm._v("\n                            Тест на права "),_c('b',[_vm._v("не")]),_vm._v(" пройден\n                            "),_c('button',{staticClass:"button is-margin-top",on:{"click":_vm.give_pdd}},[_vm._v("Выдать права")])]):_vm._e(),_vm._v(" "),_c('button',{staticClass:"button",on:{"click":function($event){_vm.show_progress=true}}},[_vm._v("Показать прогресс")])])]),_vm._v(" "),_c('b-modal',{attrs:{"active":_vm.show_progress,"width":640,"scroll":"keep"},on:{"update:active":function($event){_vm.show_progress=$event}}},[_c('div',{staticClass:"card is-margin-top"},[_c('header',{staticClass:"card-header"},[_c('p',{staticClass:"card-header-title"},[_vm._v("\n                              Пройденные тесты:\n                            ")])]),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('b-table',{attrs:{"data":_vm.user_progress,"stripped":"","paginated":"","sortable":""},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('b-table-column',{attrs:{"field":"name","label":"Название","sortable":""}},[_vm._v("\n                                  "+_vm._s(props.row.name)+"\n                                ")])]}}])})],1)])]),_vm._v(" "),_c('div',{staticClass:"is-margin-top"},[_c('a',{staticClass:"button is-primary",on:{"click":function($event){_vm.fast_edit_save()}}},[_vm._v("Сохранить")])])],1)],1)],1):_c('div',{staticClass:"is-margin-top notification"},[_vm._v("\n                  Выберите пользователя для быстрого редактирования.\n                ")])])])])]),_vm._v(" "),_c('b-tab-item',{attrs:{"label":"Добавить"}},[_c('div',{staticClass:"columns is-variable is-3"},[_c('div',{staticClass:"column is-one-third"},[_c('div',{staticClass:"box"},[_c('b-field',{staticClass:"is-margin-top",attrs:{"label":"Имя пользователя"}},[_c('b-input',{attrs:{"placeholder":"Имя пользователя"},model:{value:(_vm.new_user.username),callback:function ($$v) {_vm.$set(_vm.new_user, "username", $$v)},expression:"new_user.username"}})],1),_vm._v(" "),_c('b-field',{attrs:{"label":"Телефон"}},[_c('b-input',{attrs:{"placeholder":"Телефон"},model:{value:(_vm.new_user.phone),callback:function ($$v) {_vm.$set(_vm.new_user, "phone", $$v)},expression:"new_user.phone"}})],1),_vm._v(" "),_c('b-field',{attrs:{"label":"Пароль"}},[_c('b-input',{attrs:{"type":"password","placeholder":"Пароль","password-reveal":""},model:{value:(_vm.new_user.password),callback:function ($$v) {_vm.$set(_vm.new_user, "password", $$v)},expression:"new_user.password"}})],1),_vm._v(" "),_c('b-field',{attrs:{"label":"Подтверждение пароля"}},[_c('b-input',{attrs:{"type":"password","placeholder":"Подтверждение пароля","password-reveal":""},model:{value:(_vm.new_user.confirm),callback:function ($$v) {_vm.$set(_vm.new_user, "confirm", $$v)},expression:"new_user.confirm"}})],1),_vm._v(" "),_c('b-field',{attrs:{"label":"Роли"}},[_c('n3-select',{attrs:{"multiple":"","search":""},model:{value:(_vm.new_user.roles),callback:function ($$v) {_vm.$set(_vm.new_user, "roles", $$v)},expression:"new_user.roles"}},_vm._l((_vm.roles),function(role){return _c('n3-option',{key:role,attrs:{"value":role}},[_vm._v(_vm._s(role))])}))],1),_vm._v(" "),_c('b-field',{attrs:{"label":"Активирован"}},[_c('b-switch',{model:{value:(_vm.new_user.activated),callback:function ($$v) {_vm.$set(_vm.new_user, "activated", $$v)},expression:"new_user.activated"}})],1),_vm._v(" "),_c('a',{staticClass:"button is-primary",on:{"click":function($event){_vm.add_user()}}},[_vm._v("Добавить пользователя")]),_vm._v(" "),_c('a',{staticClass:"button",on:{"click":function($event){_vm.new_user_form_clear()}}},[_vm._v("Очистить форму")])],1)]),_vm._v(" "),_c('div',{staticClass:"column is-one-third"},[_c('div',{staticClass:"box"},[_c('photo',{model:{value:(_vm.new_user.photo),callback:function ($$v) {_vm.$set(_vm.new_user, "photo", $$v)},expression:"new_user.photo"}}),_vm._v(" "),_c('b-field',{staticClass:"is-margin-top",attrs:{"label":"Ф.И.О."}},[_c('b-input',{attrs:{"placeholder":"ФИО"},model:{value:(_vm.new_user.fio),callback:function ($$v) {_vm.$set(_vm.new_user, "fio", $$v)},expression:"new_user.fio"}})],1),_vm._v(" "),_c('b-field',{staticClass:"is-margin-top",attrs:{"label":"Дата рождения"}},[_c('b-datepicker',{attrs:{"placeholder":"Дата рождения"},model:{value:(_vm.new_user.birthday),callback:function ($$v) {_vm.$set(_vm.new_user, "birthday", $$v)},expression:"new_user.birthday"}})],1),_vm._v(" "),_c('b-field',{staticClass:"is-margin-top",attrs:{"label":"Документ"}},[_c('b-input',{attrs:{"placeholder":"Документ"},model:{value:(_vm.new_user.document_number),callback:function ($$v) {_vm.$set(_vm.new_user, "document_number", $$v)},expression:"new_user.document_number"}})],1)],1)]),_vm._v(" "),_c('div',{staticClass:"column is-one-third"},[_c('div',{staticClass:"box"},[(_vm.new_user.card_number === "0")?_c('div',{staticClass:"notification"},[_vm._v("\n                  Карта не привязана\n                ")]):_c('div',{staticClass:"notification"},[_vm._v("\n                  Номер карты: "+_vm._s(_vm.new_user.card_number)+"\n                ")]),_vm._v(" "),_c('button',{staticClass:"button",on:{"click":function($event){_vm.is_waiting_for_card=true;_vm.reader_target=_vm.new_user}}},[_vm._v("Привязать карту")]),_vm._v(" "),_c('b-field',{staticClass:"is-margin-top",attrs:{"label":"Учебное заведение"}},[_c('b-input',{attrs:{"placeholder":"Учебное заведение"},model:{value:(_vm.new_user.school),callback:function ($$v) {_vm.$set(_vm.new_user, "school", $$v)},expression:"new_user.school"}})],1),_vm._v(" "),_c('b-field',{staticClass:"is-margin-top",attrs:{"label":"Представитель"}},[_c('b-input',{attrs:{"placeholder":"Представитель"},model:{value:(_vm.new_user.representive),callback:function ($$v) {_vm.$set(_vm.new_user, "representive", $$v)},expression:"new_user.representive"}})],1),_vm._v(" "),_c('b-field',{staticClass:"is-margin-top",attrs:{"label":"Контакты представителя"}},[_c('b-input',{attrs:{"placeholder":"Контакты представителя"},model:{value:(_vm.new_user.representive_contacts),callback:function ($$v) {_vm.$set(_vm.new_user, "representive_contacts", $$v)},expression:"new_user.representive_contacts"}})],1)],1)])])])],1),_vm._v(" "),_c('b-modal',{attrs:{"active":_vm.is_waiting_for_card,"width":320,"scroll":"keep"},on:{"update:active":function($event){_vm.is_waiting_for_card=$event}}},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content text-center"},[_c('div',{staticClass:"is-margin-bottom"},[_c('img',{attrs:{"src":"static/images/icons8-foul-64.png"}})]),_vm._v(" "),_c('div',{staticClass:"is-margin-bottom"},[_vm._v("\n              Приложите карту к считывателю\n            ")])]),_vm._v(" "),(_vm.store.state.debug)?_c('footer',{staticClass:"card-footer"},[_c('a',{staticClass:"card-footer-item",on:{"click":function($event){_vm.reader_read({ card_number: String(Math.floor(Math.random()*100000000000)) })}}},[_vm._v("Случайный номер")]),_vm._v(" "),_c('a',{staticClass:"card-footer-item",on:{"click":function($event){_vm.reader_read({ card_number: "80000000001" })}}},[_vm._v("Карта 1")]),_vm._v(" "),_c('a',{staticClass:"card-footer-item",on:{"click":function($event){_vm.reader_read({ card_number: "80000000002" })}}},[_vm._v("Карта 2")]),_vm._v(" "),_c('a',{staticClass:"card-footer-item",on:{"click":function($event){_vm.reader_read({ card_number: "80000000003" })}}},[_vm._v("Карта 3")])]):_vm._e()])])],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "b6qO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_loginFormModal_vue__ = __webpack_require__("t3l5");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_812a5da4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_loginFormModal_vue__ = __webpack_require__("3/GJ");
function injectStyle (ssrContext) {
  __webpack_require__("DXcx")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-812a5da4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_loginFormModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_812a5da4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_loginFormModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "cYlJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card modal-card"},[_c('header',{staticClass:"card-header"},[_c('p',{staticClass:"card-header-title"},[_vm._v("\n      История финансов "+_vm._s(_vm.username)+"\n    ")])]),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('b-table',{attrs:{"data":_vm.log,"striped":true,"narrowed":true,"hoverable":true,"paginated":true,"per-page":10,"default-sort":"created","default-sort-direction":"desc"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('b-table-column',{attrs:{"field":"created","label":"Время","width":"180","sortable":""}},[_vm._v("\n              "+_vm._s(new Date(props.row.created).toLocaleString())+"\n            ")]),_vm._v(" "),_c('b-table-column',{attrs:{"field":"message.action","label":"Операция","width":"60","sortable":""}},[(props.row.message.action === "+")?_c('span',[_vm._v("пополнение")]):_vm._e(),_vm._v(" "),(props.row.message.action === "-")?_c('span',[_vm._v("списание")]):_vm._e(),_vm._v(" "),(props.row.message.action === "c")?_c('span',[_vm._v("коррекция")]):_vm._e()]),_vm._v(" "),_c('b-table-column',{attrs:{"field":"message.summ","label":"Сумма","width":"60","numeric":"","sortable":""}},[_vm._v("\n              "+_vm._s(props.row.message.summ)+"\n            ")]),_vm._v(" "),_c('b-table-column',{attrs:{"label":"Комментарии"}},[_vm._v("\n              "+_vm._s(props.row.message.comments)+"\n            ")])]}}])})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "dY3R":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Stats_vue__ = __webpack_require__("Woqv");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4f04e398_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Stats_vue__ = __webpack_require__("ecEW");
function injectStyle (ssrContext) {
  __webpack_require__("hrZ9")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Stats_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4f04e398_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Stats_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "doPI":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "dxC/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__FinanceLog_vue__ = __webpack_require__("RJ9I");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__bus__ = __webpack_require__("14gb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Photo_vue__ = __webpack_require__("X68B");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store__ = __webpack_require__("olkN");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





// import webcam from 'vue-web-cam/src/webcam'

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Users',
  data: function data() {
    this.$parent.active_tab = 'users';
    this.fetch_data();
    __WEBPACK_IMPORTED_MODULE_2__bus__["a" /* EventBus */].$on('ws_on_message', this.ws_on_message);
    return {
      data_loading: true,
      active_tab: 0,
      users: [{ username: '', phone: '', activated: true, created: 0 }],
      selected_user: {},
      new_user: { username: '', phone: '', password: '', confirm: '', roles: ['client'], activated: false, fio: '', document_number: '', birthday: new Date(), card_number: '0', photo: { audio: { name: '', filename: '', filetype: '', filesize: 0 }, image: { name: '', filename: '', filetype: '', filesize: 0 }, video: { name: '', filename: '', filetype: '', filesize: 0 } }, school: '', representive: '', representive_contacts: '' },
      change_password: '',
      change_confirm: '',
      roles: ['admin', 'manager', 'client', 'client_manager', 'police', 'garage'],
      money_operation: [{ id: '+', label: 'Пополнение' }, { id: '-', label: 'Списание' }, { id: 'c', label: 'Коррекция' }],
      search_string: '',
      finance_history: [],
      finance_new: { summ: '', action: '', comments: '' },
      is_waiting_for_card: false,
      reader_target: '',
      is_taking_photo: false,
      photo_target: {},
      test_names: {},
      show_progress: false,
      store: __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */]
    };
  },
  components: {
    photo: __WEBPACK_IMPORTED_MODULE_3__Photo_vue__["a" /* default */]
  },
  methods: {
    fetch_data: function fetch_data() {
      var t = this;
      t.data_loading = true;
      var form = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({ method: 'admin_get_users', params: {} });
      window.$.post(window.gw + 'async_api/user', { data: form }, function (r) {
        var d = JSON.parse(r);
        if (d.result === 'ok') {
          d.params.users.forEach(function (user) {
            t.prepare_user(user);
          });
          t.users = d.params.users;
          t.data_loading = false;
          t.test_names = d.params.test_names;
          if (t.test_names[0] !== undefined) delete t.test_names[0];
          // if (t.selected_user !== {}) {
          // }
        }
      });
      return;
    },
    fast_edit_save: function fast_edit_save() {
      var t = this;
      if (t.change_password !== t.change_confirm) {
        t.$toast.open({ message: 'passwords does not match' });return;
      }
      if (t.change_password.length > 0) {
        if (t.change_password.length < 5) {
          t.$toast.open({ message: 'password too short' });return;
        }
        t.selected_user.password = t.change_password;
      }
      var form = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({ method: 'admin_update_user', params: { user: t.selected_user } });
      window.$.post(window.gw + 'api/user', { data: form }, function (r) {
        var d = JSON.parse(r);
        if (d.result === 'ok') {
          t.$toast.open({
            message: 'SAVED!',
            type: 'is-success'
          });
          if (t.change_password.length > 0) {
            delete t.selected_user.password;
            t.change_password = '';
            t.change_confirm = '';
          }
          // t.fetch_data()
        } else {
          t.$toast.open({
            message: d.params.msg,
            type: 'is-danger'
          });
        }
      });
      return;
    },
    add_user: function add_user() {
      var t = this;
      if (t.new_user.username.length < 5) {
        t.$toast.open({ message: 'username too short' });return;
      }
      if (t.new_user.password.length < 5) {
        t.$toast.open({ message: 'password required' });return;
      }
      if (t.new_user.password !== t.new_user.confirm) {
        t.$toast.open({ message: 'passwords does not match' });return;
      }
      var form = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({ method: 'admin_add_user', params: { user: t.new_user } });
      window.$.post(window.gw + 'api/user', { data: form }, function (r) {
        var d = JSON.parse(r);
        if (d.result === 'ok') {
          t.$toast.open({
            message: 'SAVED!',
            type: 'is-success'
          });
          t.new_user = { username: '', phone: '', password: '', confirm: '', roles: ['client'], activated: false, fio: '', document_number: '', birthday: new Date(), card_number: '0', photo: { audio: { name: '', filename: '', filetype: '', filesize: 0 }, image: { name: '', filename: '', filetype: '', filesize: 0 }, video: { name: '', filename: '', filetype: '', filesize: 0 } }, school: '', representive: '', representive_contacts: ''
            // t.fetch_data()
          };
        } else {
          t.$toast.open({
            message: d.params.msg,
            type: 'is-danger'
          });
        }
      });
      return;
    },
    new_user_form_clear: function new_user_form_clear() {
      this.new_user = { username: '', phone: '', password: '', confirm: '', roles: ['client'], activated: false, fio: '', document_number: '', birthday: new Date(), card_number: '0', photo: { audio: { name: '', filename: '', filetype: '', filesize: 0 }, image: { name: '', filename: '', filetype: '', filesize: 0 }, video: { name: '', filename: '', filetype: '', filesize: 0 } }, school: '', representive: '', representive_contacts: '' };
      return;
    },
    finance_execute: function finance_execute() {
      var _this = this;
      var form = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({ method: 'admin_edit_user_finance', params: { username: _this.selected_user.username, summ: _this.finance_new.summ, action: _this.finance_new.action, comments: _this.finance_new.comments } });
      window.$.post(window.gw + 'api/finance', { data: form }, function (r) {
        var d = JSON.parse(r);
        if (d.result === 'ok') {
          _this.$toast.open({
            message: 'Готово!',
            type: 'is-success'
          });
          // _this.fetch_data()
          // var action = _this.finance_new.action
          // if (action === '+') _this.selected_user.balance += Number(_this.finance_new.summ)
          // if (action === '-') _this.selected_user.balance -= Number(_this.finance_new.summ)
          // if (action === 'c') _this.selected_user.balance += Number(_this.finance_new.summ)
          _this.finance_new.summ = '';
          _this.finance_new.action = '';
          _this.finance_new.comments = '';
        } else {
          _this.$toast.open({
            message: d.params.msg,
            type: 'is-danger'
          });
        }
      });
    },
    open_finance_history: function open_finance_history() {
      this.$modal.open({ parent: this, component: __WEBPACK_IMPORTED_MODULE_1__FinanceLog_vue__["a" /* default */], hasModalCard: true, formProps: { 'username': this.selected_user.username } });
    },
    ws_on_message: function ws_on_message(message) {
      message = JSON.parse(message);
      var method = message.method;
      var params = message.params;
      if (method === 'reader_read') this.reader_read(params);
      if (method === 'update_user') this.ws_update_user(params);
      if (method === 'add_user') this.ws_add_user(params);
    },
    reader_read: function reader_read(params) {
      var cnumber = params.card_number;
      this.reader_target.card_number = cnumber;
      this.is_waiting_for_card = false;
      console.log(cnumber);
    },
    shoot_photo: function shoot_photo(params) {
      this.photo_target.photo = this.$refs.webcam.capture();
      this.is_taking_photo = false;
      console.log(this.new_user.photo);
    },
    date_parser: function date_parser(date) {
      console.log(date);
      var d = new Date(Date.parse(date));
      return d;
    },
    give_pdd: function give_pdd() {
      var _t = this;
      var form = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({ method: 'admin_give_pdd', params: { user: _t.selected_user } });
      window.$.post(window.gw + 'api/user', { data: form }, function (r) {
        var d = JSON.parse(r);
        if (d.result === 'ok') {
          _t.selected_user.balance += 20;
          _t.selected_user.progress[__WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].state.pdd_oid] = 0;
          _t.selected_user.got_pdd = true;
        }
      });
    },
    take_pdd: function take_pdd() {
      var _t = this;
      var form = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({ method: 'admin_take_pdd', params: { user: _t.selected_user } });
      window.$.post(window.gw + 'api/user', { data: form }, function (r) {
        var d = JSON.parse(r);
        if (d.result === 'ok') {
          // _t.selected_user.progress[store.state.pdd_oid] = undefined
          delete _t.selected_user.progress[__WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].state.pdd_oid];
          _t.selected_user.got_pdd = false;
        }
      });
    },
    ws_update_user: function ws_update_user(params) {
      var updated = params.user;
      this.prepare_user(updated);
      this.users.forEach(function (user) {
        if (user._id.$oid === updated._id.$oid) {
          for (var key in updated) {
            user[key] = updated[key];
          }
        }
      });
    },
    ws_add_user: function ws_add_user(params) {
      this.users.push(params.user);
    },
    prepare_user: function prepare_user(user) {
      if (user.birthday !== undefined) {
        if (user.birthday !== '') user.birthday = new Date(Date.parse(user.birthday));else user.birthday = new Date('1-1-1911');
      }
      if (user.progress !== undefined) {
        if (user.progress[__WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].state.pdd_oid] !== undefined) {
          user.got_pdd = true;
        } else {
          user.got_pdd = false;
        }
      }
    },
    birthday_sort: function birthday_sort(a, b, isAsc) {
      var q = new Date(a.birthday);
      var w = new Date(b.birthday);
      var now = new Date();
      var dnow = new Date(0, now.getMonth(), now.getDate());
      var d1 = new Date(0, q.getMonth(), q.getDate());
      var d2 = new Date(0, w.getMonth(), w.getDate());
      if (d1 < dnow) d1 = new Date(9999, 0, 0);
      if (d2 < dnow) d2 = new Date(9999, 0, 0);
      return Math.abs(d1 - dnow) - Math.abs(d2 - dnow);
    }
  },
  computed: {
    table_data: function table_data() {
      var _this = this;
      if (this.search_string.length < 3) return this.users;
      return this.users.filter(function (user) {
        if (user.username !== undefined) {
          if (user.username.toUpperCase().indexOf(_this.search_string.toUpperCase()) >= 0) return true;
        }
        if (user.phone !== undefined) {
          if (user.phone.toUpperCase().indexOf(_this.search_string.toUpperCase()) >= 0) return true;
        }
        if (user.fio !== undefined) {
          if (user.fio.toUpperCase().indexOf(_this.search_string.toUpperCase()) >= 0) return true;
        }
        if (user.document_number !== undefined) {
          if (user.document_number.toUpperCase().indexOf(_this.search_string.toUpperCase()) >= 0) return true;
        }
        if (user.card_number !== undefined) {
          if (user.card_number.toString().toUpperCase().indexOf(_this.search_string.toUpperCase()) >= 0) return true;
        }
        return false;
      });
    },
    finance_new_ready: function finance_new_ready() {
      if (this.finance_new.summ >= 0 && this.finance_new.action !== '') return true;
      return false;
    },
    got_pdd: function got_pdd() {
      if (this.selected_user === {}) return false;
      var p = false;
      if (this.selected_user.progress[__WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].state.pdd_oid] !== undefined) p = true;
      return p;
    },
    user_progress: function user_progress() {
      if (this.selected_user === {}) return false;
      var p = [];
      for (var i in this.selected_user.progress) {
        p.push({ _id: i, name: this.test_names[i], last: this.selected_user.progress[i] });
      }
      return p;
    }
  }
});

/***/ }),

/***/ "ecEW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"stats is-margin-top"},[_c('section',[_c('div',{staticClass:"container is-margin-top"},[_c('h1',{staticClass:"title"},[_vm._v("Отчеты")]),_vm._v(" "),_c('div',{staticClass:"columns box is-margin-top"},[_c('div',{staticClass:"column"},[_c('b-field',{attrs:{"label":"От"}},[_c('b-datepicker',{attrs:{"placeholder":"Выберите дату"},model:{value:(_vm.date_from),callback:function ($$v) {_vm.date_from=$$v},expression:"date_from"}})],1),_vm._v(" "),_c('b-field',{attrs:{"label":"До"}},[_c('b-datepicker',{attrs:{"placeholder":"Выберите дату"},model:{value:(_vm.date_due),callback:function ($$v) {_vm.date_due=$$v},expression:"date_due"}})],1),_vm._v(" "),_c('b-field',{attrs:{"label":"Тип отчета"}},[_c('b-select',{attrs:{"placeholder":"Выберите тип отчета"},model:{value:(_vm.report_type),callback:function ($$v) {_vm.report_type=$$v},expression:"report_type"}},_vm._l((_vm.report_types),function(option){return _c('option',{key:option.type,domProps:{"value":option.type}},[_vm._v("\n                "+_vm._s(option.label)+"\n              ")])}))],1)],1),_vm._v(" "),_c('div',{staticClass:"column box"},[_c('button',{staticClass:"button is-fullwidth is-small-margin-top is-info",on:{"click":_vm.show_reports}},[_vm._v("Подготовить")]),_vm._v(" "),_c('button',{staticClass:"button is-fullwidth is-small-margin-top",attrs:{"disabled":""}},[_vm._v("Печать \\ Сохранить в pdf")]),_vm._v(" "),_c('button',{staticClass:"button is-fullwidth is-small-margin-top",attrs:{"disabled":""}},[_vm._v("Скачать данные")])])]),_vm._v(" "),(_vm.state === "stats")?_c('div',{staticClass:"container is-margin-top myDivToPrint"},[_c('div',{staticClass:"is-margin-top-20"},[_c('vue-frappe',{attrs:{"id":"users_chart","labels":_vm.charts_data.labels,"title":"Пользователи","type":"axis-mixed","height":300,"dataSets":[_vm.charts_data.new_users, _vm.charts_data.returning_users],"barOptions":{stacked: 1},"tooltipOptions":{formatTooltipY: function (d) { return d + ''; }}}})],1),_vm._v(" "),_c('div',{staticClass:"is-margin-top-20"},[_c('vue-frappe',{attrs:{"id":"money_chart","labels":_vm.charts_data.labels,"title":"Оборот ладушек","type":"axis-mixed","height":300,"dataSets":[_vm.charts_data.earnings, _vm.charts_data.spendings],"barOptions":{stacked: 1},"tooltipOptions":{formatTooltipY: function (d) { return d + ''; }}}})],1),_vm._v(" "),_c('div',{staticClass:"is-margin-top-20"},[_c('vue-frappe',{attrs:{"id":"tests_chart","labels":_vm.charts_data.labels,"title":"Тесты","type":"axis-mixed","height":300,"dataSets":[_vm.charts_data.test_passed, _vm.charts_data.test_tries],"barOptions":{stacked: 1},"tooltipOptions":{formatTooltipY: function (d) { return d + ''; }}}})],1),_vm._v(" "),_c('div',{staticClass:"is-margin-top-20"},[_c('vue-frappe',{attrs:{"id":"rents_chart","labels":_vm.charts_data.labels,"title":"Развлечения, аренда","type":"axis-mixed","height":300,"dataSets":[_vm.charts_data.vgm_rents, _vm.charts_data.car_electro_rents, _vm.charts_data.car_manual_rents],"barOptions":{stacked: 1},"tooltipOptions":{formatTooltipY: function (d) { return d + ''; }}}})],1),_vm._v(" "),_c('div',{staticClass:"is-margin-top-20"},[_c('vue-frappe',{attrs:{"id":"spendings_chart","labels":_vm.charts_data.labels,"title":"Развлечения, затраты ладушек","type":"axis-mixed","height":300,"dataSets":[_vm.charts_data.vgm_spendings, _vm.charts_data.car_electro_spendings, _vm.charts_data.car_manual_spendings],"barOptions":{stacked: 1},"tooltipOptions":{formatTooltipY: function (d) { return d + ''; }}}})],1)]):_vm._e(),_vm._v(" "),(_vm.state === "aggregated")?_c('div',{staticClass:"container is-margin-top myDivToPrint"},[_c('div',{staticClass:"is-margin-top-20"},[_c('vue-frappe',{attrs:{"id":"a_users_chart","labels":_vm.aggregated_chart.users.labels,"title":"Посещения","type":"percentage","height":130,"barOptions":_vm.barOptions,"dataSets":[_vm.aggregated_chart.users.new_users],"tooltipOptions":{formatTooltipY: function (d) { return d + ''; }}}})],1),_vm._v(" "),_c('div',{staticClass:"is-margin-top-20"},[_c('vue-frappe',{attrs:{"id":"a_spendings_chart","labels":['Машины', 'Игровые автоматы'],"title":"Затраты ладушек","type":"percentage","height":130,"barOptions":_vm.barOptions,"dataSets":[_vm.aggregated_chart.spendings],"tooltipOptions":{formatTooltipY: function (d) { return d + ''; }}}})],1),_vm._v(" "),_c('div',{staticClass:"box"},[_c('div',{staticStyle:{"height":"100px"}},[_vm._v("Тесты")]),_vm._v(" "),_c('div',{staticClass:"packed-top"},[_c('vue-frappe',{attrs:{"id":"a_tests_chart","labels":_vm.aggregated_chart.tests.labels,"title":"Сводная статистика","type":"percentage","height":130,"barOptions":_vm.barOptions,"dataSets":[_vm.aggregated_chart.tests.tries],"tooltipOptions":{formatTooltipY: function (d) { return d + ''; }}}})],1),_vm._v(" "),_vm._l((_vm.aggregated_chart.tests.tests),function(test){return _c('div',{key:"id",staticClass:"packed-top"},[_c('vue-frappe',{attrs:{"id":'a_tests_chart_' + test.id,"labels":_vm.aggregated_chart.tests.labels,"title":test.title,"type":"percentage","height":130,"barOptions":_vm.barOptions,"dataSets":[test.data],"tooltipOptions":{formatTooltipY: function (d) { return d + ''; }}}})],1)})],2),_vm._v(" "),_c('div',{staticClass:"box is-margin-top-20"},[_c('div',{staticStyle:{"height":"50px"}},[_vm._v("Машины")]),_vm._v(" "),_c('div',{staticClass:"is-margin-top-20"},[_c('vue-frappe',{attrs:{"id":"a_cars_spendings_chart","labels":_vm.aggregated_chart.cars.car_types.labels,"title":_vm.aggregated_chart.cars.car_types.name,"type":"percentage","height":130,"barOptions":_vm.barOptions,"dataSets":[_vm.aggregated_chart.cars.car_types],"tooltipOptions":{formatTooltipY: function (d) { return d + ''; }}}})],1)]),_vm._v(" "),_c('div',{staticClass:"box is-margin-top-20"},[_c('div',{staticStyle:{"height":"50px"}},[_vm._v("Игровые аппараты:")]),_vm._v(" "),_c('ul',_vm._l((Object.keys(_vm.aggregated_chart.vgms.raw)),function(vgm){return _c('li',[_c('b',[_vm._v(_vm._s(vgm))]),_vm._v(" - Потрачено "),_c('b',[_vm._v(_vm._s(_vm.aggregated_chart.vgms.raw[vgm].spendings))]),_vm._v(" ладушек на "),_c('b',[_vm._v(_vm._s(_vm.aggregated_chart.vgms.raw[vgm].rents))]),_vm._v(" аренд.  \n            ")])}))])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"is-margin-top"}),_vm._v(" "),_c('div',{staticStyle:{"height":"100px"}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "h8rG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Chart_vue__ = __webpack_require__("UOFx");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_441a1f2f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Chart_vue__ = __webpack_require__("2KWe");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Chart_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_441a1f2f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Chart_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "hi9z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__("olkN");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'devices',
  data: function data() {
    this.$parent.active_tab = 'devices';
    this.fetch_data();
    return {
      store: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */],
      activeTab: 0,
      data_loading: false,
      clients: [],
      readers: [],
      admins: [],
      selected_client: {},
      selected_reader: {},
      client_actions: [
      // {id: 0, label: 'Выберите действие'},
      {}, { id: 1, label: 'Выход с аккаунта', method: 'logout', params: {} }, { id: 2, label: 'Залогинить', method: 'login_as', params: { username: '' } }, { id: 3, label: 'Пинг', method: 'show_loading', params: {} }, { id: 4, label: 'Перезапустить', method: 'reload_page', params: {} }, { id: 105, label: 'Карта 1', method: 'reader_read', params: { card_number: '80000000001' } }, { id: 106, label: 'Карта 2', method: 'reader_read', params: { card_number: '80000000002' } }, { id: 107, label: 'Карта 3', method: 'reader_read', params: { card_number: '80000000003' } }],
      selected_client_action: {},
      reader_actions: [],
      selected_reader_action: {}
    };
  },

  methods: {
    fetch_data: function fetch_data() {
      var t = this;
      t.data_loading = true;
      var form = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({ method: 'admin_get_devices', params: {} });
      window.$.post(window.gw + 'api/device', { data: form }, function (r) {
        var d = JSON.parse(r);
        if (d.result === 'ok') {
          t.clients = d.params.clients;
          t.readers = d.params.readers;
          t.admins = d.params.admins;
          t.vgms = d.params.vgms;
          t.data_loading = false;
        }
      });
      return;
    },
    save_client: function save_client() {
      var t = this;
      t.data_loading = true;
      var form = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({ method: 'admin_save_device', params: { device: t.selected_client } });
      window.$.post(window.gw + 'api/device', { data: form }, function (r) {
        var d = JSON.parse(r);
        if (d.result === 'ok') {
          t.data_loading = false;
        }
      });
      return;
    },
    run_client_action: function run_client_action() {
      var t = this;
      console.log(t.selected_client_action);
      if (!t.selected_client_action.hasOwnProperty('method')) return;
      if (t.selected_client_action.id > 100) {
        // store.commit('ws_send', t.selected_client_action)
        this.$socket.send(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(t.selected_client_action));
        return;
      }
      t.data_loading = true;
      var form = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({ method: 'admin_run_action', params: { device: t.selected_client, action: t.selected_client_action } });
      window.$.post(window.gw + 'api/device', { data: form }, function (r) {
        var d = JSON.parse(r);
        if (d.result === 'ok') {
          t.data_loading = false;
          t.selected_client_action = {};
        }
      });
      return;
    }
  }
});

/***/ }),

/***/ "hrZ9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "jgfr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"notification"},[(_vm.value.image.filename !== "")?_c('img',{staticStyle:{"width":"100%"},attrs:{"src":_vm.static + _vm.value.image.filename}}):_c('div',[_vm._v("Нет фотографии")]),_vm._v(" "),_c('button',{staticClass:"button is-margin-top",on:{"click":function($event){_vm.is_taking_photo=true}}},[_vm._v("Сфотографировать")])]),_vm._v(" "),_c('b-modal',{attrs:{"active":_vm.is_taking_photo,"width":1280,"height":720,"scroll":"keep"},on:{"update:active":function($event){_vm.is_taking_photo=$event}}},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content"},[_c('webcam',{ref:"webcam",staticClass:"webcam",attrs:{"width":700}}),_vm._v(" "),_c('button',{staticClass:"button",attrs:{"type":"button"},on:{"click":function($event){_vm.photo()}}},[_vm._v("Сфотографировать")])],1)])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "jvAN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_webcam_vue__ = __webpack_require__("Fi4I");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2f22d815_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_webcam_vue__ = __webpack_require__("QhQe");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_webcam_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2f22d815_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_webcam_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "lWtS":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "libW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Tests',
  data: function data() {
    this.$parent.active_tab = 'tests';
    this.fetch_data();
    return {
      activeTab: 0,
      question_id: 1,
      data_loading: true,
      data_tests: [],
      selected_test: {},
      new_test_name: '',
      is_question_search: false,
      is_asking_for_test_name: false,
      new_test: { 'name': '', 'length': 0, 'changed': '', 'level': 0, 'active': false },
      empty_question: {
        text: '',
        on_open: { audio: { name: '', filename: '', filetype: '', filesize: 0 }, image: { name: '', filename: '', filetype: '', filesize: 0 }, video: { name: '', filename: '', filetype: '', filesize: 0 } },
        on_pass: { audio: { name: '', filename: '', filetype: '', filesize: 0 }, image: { name: '', filename: '', filetype: '', filesize: 0 }, video: { name: '', filename: '', filetype: '', filesize: 0 } },
        on_fail: { audio: { name: '', filename: '', filetype: '', filesize: 0 }, image: { name: '', filename: '', filetype: '', filesize: 0 }, video: { name: '', filename: '', filetype: '', filesize: 0 } },
        answer1_text: '',
        answer1_media: { audio: { name: '', filename: '', filetype: '', filesize: 0 }, image: { name: '', filename: '', filetype: '', filesize: 0 }, video: { name: '', filename: '', filetype: '', filesize: 0 } },
        answer2_text: '',
        answer2_media: { audio: { name: '', filename: '', filetype: '', filesize: 0 }, image: { name: '', filename: '', filetype: '', filesize: 0 }, video: { name: '', filename: '', filetype: '', filesize: 0 } },
        answer3_text: '',
        answer3_media: { audio: { name: '', filename: '', filetype: '', filesize: 0 }, image: { name: '', filename: '', filetype: '', filesize: 0 }, video: { name: '', filename: '', filetype: '', filesize: 0 } },
        answer4_text: '',
        answer4_media: { audio: { name: '', filename: '', filetype: '', filesize: 0 }, image: { name: '', filename: '', filetype: '', filesize: 0 }, video: { name: '', filename: '', filetype: '', filesize: 0 } },
        right_answer: 1
      }
    };
  },

  methods: {
    fetch_data: function fetch_data() {
      var t = this;
      t.data_loading = true;
      var form = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({ method: 'admin_get_tests', params: {} });
      window.$.post(window.gw + 'api/game', { data: form }, function (r) {
        var d = JSON.parse(r);
        if (d.result === 'ok') {
          t.data_tests = d.params.tests;
          t.data_loading = false;
          t.data_tests.forEach(function (test) {
            if (test.questions === undefined) test.questions = [];
          });
        }
      });
      return;
    },
    add_test_button_click: function add_test_button_click() {
      // this.$dialog.alert('Everything looks fine!')
      // this.$dialog.prompt({
      //   message: 'Введите название теста',
      //   inputAttrs: {
      //     placeholder: 'Название теста',
      //     maxlength: 255
      //   },
      //   onConfirm: (value) => this.add_test(value)
      // })
      // this.add_test('Новый тест')
      this.is_asking_for_test_name = true;
    },
    create_test: function create_test() {
      if (this.new_test_name !== '') this.add_test(this.new_test_name);
      this.new_test_name = '';
      this.is_asking_for_test_name = false;
    },
    add_test: function add_test(name) {
      var t = this;
      t.data_loading = true;
      var form = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({ method: 'admin_add_test', params: { 'testname': name } });
      window.$.post(window.gw + 'api/game', { data: form }, function (r) {
        var d = JSON.parse(r);
        if (d.result === 'ok') {
          t.fetch_data();
          t.$toast.open('Готово!');
        }
      });
      return;
    },
    close_new_test_modal: function close_new_test_modal() {
      this.is_asking_for_test_name = false;
      this.new_test_name = '';
    },
    save_selected_test: function save_selected_test() {
      var t = this;
      t.data_loading = true;
      var form = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({ method: 'admin_save_test', params: { 'test': t.selected_test } });
      window.$.post(window.gw + 'api/game', { data: form }, function (r) {
        var d = JSON.parse(r);
        if (d.result === 'ok') {
          // t.fetch_data()
          t.$toast.open('Готово!');
        }
        t.data_loading = false;
      });
      return;
    },
    add_question_to_selected_test: function add_question_to_selected_test() {
      // this.selected_test.questions.push(Object.assign({}, this.empty_question))
      this.selected_test.questions.push(JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.empty_question)));
      this.question_id = this.selected_test.questions.length;
    },
    delete_question: function delete_question(question) {
      this.selected_test.questions.splice(this.selected_test.questions.indexOf(question), 1);
      this.prev_question();
    },
    next_question: function next_question() {
      if (this.question_id + 1 > this.selected_test.questions.length) return;
      this.question_id++;
    },
    prev_question: function prev_question() {
      if (this.question_id - 1 === 0) return;
      this.question_id--;
    },
    select_question_id: function select_question_id(id) {
      this.question_id = id;
      this.is_question_search = false;
    }
  },
  computed: {
    current_question: function current_question() {
      if (this.selected_test === {}) return null;
      if (this.selected_test.questions === undefined) return null;
      if (this.question_id < 1) return null;
      if (this.question_id > this.selected_test.questions.length) return null;
      return this.selected_test.questions[this.question_id - 1];
    },
    questions_table: function questions_table() {
      var t = [];
      if (this.selected_test === {}) return t;
      if (this.selected_test === undefined) return t;
      if (this.selected_test.questions === undefined) return t;
      this.selected_test.questions.forEach(function (test, i) {
        console.log(test, i);
        t.push({ id: ++i, name: test.text });
      });
      return t;
    }
  }
});

/***/ }),

/***/ "olkN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__bus_js__ = __webpack_require__("14gb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
// store.js



__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* default */]);

// app initial state
var state = {
  socket: {
    is_connected: false,
    message: '',
    reconnect_error: false
  },
  count: 0,
  empty_user: {
    username: '',
    balance: 0,
    progress: {}
  },
  user: {
    username: '',
    balance: 0,
    progress: {}
  },
  session: {
    session_id: ''
  },
  show_menu: false,
  debug: true,
  pdd_oid: '5ac0f57112df2203d397dc4c'

  // define possible mutations
};var mutations = {
  set_user: function set_user(state, user) {
    state.user = user;
  },
  set_show_menu: function set_show_menu(state, s) {
    state.show_menu = s;
  },
  INCREMENT: function INCREMENT(state) {
    state.count++;
  },
  DECREMENT: function DECREMENT(state) {
    state.count--;
  },
  SOCKET_ONOPEN: function SOCKET_ONOPEN(state, event) {
    state.socket.is_connected = true;
  },
  SOCKET_ONCLOSE: function SOCKET_ONCLOSE(state, event) {
    state.socket.is_connected = false;
  },
  SOCKET_ONERROR: function SOCKET_ONERROR(state, event) {
    console.error('socket', 'on_error', state, event);
    __WEBPACK_IMPORTED_MODULE_1__bus_js__["a" /* EventBus */].$emit('ws_on_error', event);
  },
  SOCKET_RECONNECT: function SOCKET_RECONNECT(state, count) {
    console.info('socket', 'reconnect', state, count);
  },
  SOCKET_RECONNECT_ERROR: function SOCKET_RECONNECT_ERROR(state) {
    console.socket.reconnect_error = true;
    console.error('socket', 'reconnect');
  },
  SOCKET_ONMESSAGE: function SOCKET_ONMESSAGE(state, event) {
    __WEBPACK_IMPORTED_MODULE_1__bus_js__["a" /* EventBus */].$emit('ws_on_message', event.data);
  },
  ws_send: function ws_send(state, msg) {
    console.log(this.$socket);
  }
};

// create the store
/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* default */].Store({
  state: state,
  mutations: mutations
}));

/***/ }),

/***/ "p/gC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"devices is-margin-top"},[_c('section',[_c('div',{staticClass:"container"},[_c('nav',{staticClass:"breadcrumb",attrs:{"aria-label":"breadcrumbs"}},[_c('ul',[_c('li',{staticClass:"is-active"},[_c('button',{staticClass:"button",attrs:{"id":"refresh_button"},on:{"click":function($event){_vm.fetch_data()}}},[_c('b-icon',{attrs:{"icon":"refresh"}})],1),_vm._v(" "),_c('a',{attrs:{"href":"#/tests","aria-current":"page"}},[_vm._v("  Список Устройств")])])])]),_vm._v(" "),_c('b-tabs',{attrs:{"animated":false,"type":"is-toggle"},model:{value:(_vm.activeTab),callback:function ($$v) {_vm.activeTab=$$v},expression:"activeTab"}},[_c('b-tab-item',{attrs:{"label":"Клиенты"}},[_c('div',{staticClass:"columns is-margin-top"},[_c('div',{staticClass:"column is-two-thirds"},[_c('b-table',{attrs:{"data":_vm.clients,"selected":_vm.selected_client,"loading":_vm.data_loading,"paginated":""},on:{"update:selected":function($event){_vm.selected_client=$event}},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('b-table-column',{attrs:{"field":"room","label":"Помещение","width":"100","sortable":""}},[_vm._v("\n                    "+_vm._s(props.row.room)+"\n                  ")]),_vm._v(" "),_c('b-table-column',{attrs:{"field":"name","label":"Название","width":"100","sortable":""}},[_vm._v("\n                    "+_vm._s(props.row.name)+"\n                  ")]),_vm._v(" "),_c('b-table-column',{attrs:{"field":"level","label":"Сложность","width":"100","sortable":""}},[_vm._v("\n                    "+_vm._s(props.row.level)+"\n                  ")]),_vm._v(" "),_c('b-table-column',{attrs:{"field":"name","label":"Страница","width":"100","sortable":""}},[_vm._v("\n                    "+_vm._s(props.row.current_page)+"\n                  ")]),_vm._v(" "),_c('b-table-column',{attrs:{"field":"status","label":"Статус","width":"100","sortable":""}},[(props.row.status === "online")?_c('span',{staticClass:"tag is-success"},[_vm._v(_vm._s(props.row.status))]):_vm._e(),_vm._v(" "),(props.row.status === "offline")?_c('span',{staticClass:"tag is-danger"},[_vm._v(_vm._s(props.row.status))]):_vm._e()]),_vm._v(" "),_c('b-table-column',{attrs:{"field":"lastseen","label":"Онлайн","width":"100","sortable":""}},[_vm._v("\n                    "+_vm._s(new Date(props.row.lastseen).toLocaleString())+"\n                  ")])]}}])})],1),_vm._v(" "),_c('div',{staticClass:"column is-one-third"},[_c('section',{staticClass:"is-margin-top box fast_edit"},[(_vm.selected_client.hasOwnProperty("_id"))?_c('b-tabs',{staticClass:"block",attrs:{"animated":false}},[_c('b-tab-item',{attrs:{"label":"Основные"}},[_c('b-field',{staticClass:"is-margin-top",attrs:{"label":"Название"}},[_c('b-input',{attrs:{"placeholder":"Название"},model:{value:(_vm.selected_client.name),callback:function ($$v) {_vm.$set(_vm.selected_client, "name", $$v)},expression:"selected_client.name"}})],1),_vm._v(" "),_c('b-field',{staticClass:"is-margin-top",attrs:{"label":"Помещение"}},[_c('b-input',{attrs:{"placeholder":"Помещение"},model:{value:(_vm.selected_client.room),callback:function ($$v) {_vm.$set(_vm.selected_client, "room", $$v)},expression:"selected_client.room"}})],1),_vm._v(" "),_c('b-field',{staticClass:"is-margin-top",attrs:{"label":"Сложность"}},[_c('b-input',{attrs:{"placeholder":"Сложность"},model:{value:(_vm.selected_client.level),callback:function ($$v) {_vm.$set(_vm.selected_client, "level", $$v)},expression:"selected_client.level"}})],1),_vm._v(" "),_c('b-field',{staticClass:"is-margin-top",attrs:{"label":"Кол-во вопросов"}},[_c('b-input',{attrs:{"placeholder":"Кол-во вопросов"},model:{value:(_vm.selected_client.answers_needed),callback:function ($$v) {_vm.$set(_vm.selected_client, "answers_needed", $$v)},expression:"selected_client.answers_needed"}})],1),_vm._v(" "),_c('b-field',{staticClass:"is-margin-top"},[_c('button',{staticClass:"button",on:{"click":function($event){_vm.save_client()}}},[_vm._v("сохранить")])])],1),_vm._v(" "),_c('b-tab-item',{attrs:{"label":"Действия"}},[_c('b-field',{attrs:{"label":"Действия"}},[_c('b-select',{attrs:{"placeholder":"Выберите действие"},model:{value:(_vm.selected_client_action),callback:function ($$v) {_vm.selected_client_action=$$v},expression:"selected_client_action"}},_vm._l((_vm.client_actions),function(action){return _c('option',{key:action.id,domProps:{"value":action}},[_vm._v(_vm._s(action.label))])}))],1),_vm._v(" "),(_vm.selected_client_action.hasOwnProperty("method"))?_c('div',{staticClass:"notification"},[(_vm.selected_client_action.method === "login_as")?_c('b-field',{attrs:{"label":"Пользователь"}},[_c('b-input',{model:{value:(_vm.selected_client_action.params.username),callback:function ($$v) {_vm.$set(_vm.selected_client_action.params, "username", $$v)},expression:"selected_client_action.params.username"}})],1):_vm._e()],1):_vm._e(),_vm._v(" "),_c('b-field',[_c('button',{staticClass:"button",on:{"click":function($event){_vm.run_client_action()}}},[_vm._v("Выполнить")])])],1)],1):_c('div',{staticClass:"is-margin-top notification"},[_vm._v("\n                  Выберите устройство для быстрого редактирования.\n                ")])],1)])])]),_vm._v(" "),_c('b-tab-item',{attrs:{"label":"Считыватели"}},[_c('div',{staticClass:"columns is-margin-top"},[_c('div',{staticClass:"column is-two-thirds"},[_c('b-table',{attrs:{"data":_vm.readers,"selected":_vm.selected_client,"loading":_vm.data_loading,"paginated":""},on:{"update:selected":function($event){_vm.selected_client=$event}},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('b-table-column',{attrs:{"field":"room","label":"Помещение","width":"100","sortable":""}},[_vm._v("\n                    "+_vm._s(props.row.room)+"\n                  ")]),_vm._v(" "),_c('b-table-column',{attrs:{"field":"name","label":"Название","width":"100","sortable":""}},[_vm._v("\n                    "+_vm._s(props.row.name)+"\n                  ")]),_vm._v(" "),_c('b-table-column',{attrs:{"field":"status","label":"Статус","width":"100","sortable":""}},[(props.row.status === "online")?_c('span',{staticClass:"tag is-success"},[_vm._v(_vm._s(props.row.status))]):_vm._e(),_vm._v(" "),(props.row.status === "offline")?_c('span',{staticClass:"tag is-danger"},[_vm._v(_vm._s(props.row.status))]):_vm._e()]),_vm._v(" "),_c('b-table-column',{attrs:{"field":"lastseen","label":"Онлайн","width":"100","sortable":""}},[_vm._v("\n                    "+_vm._s(new Date(props.row.lastseen).toLocaleString())+"\n                  ")])]}}])})],1),_vm._v(" "),_c('div',{staticClass:"column is-one-third"},[_c('section',{staticClass:"is-margin-top box fast_edit"},[(_vm.selected_client.hasOwnProperty("_id"))?_c('b-tabs',{staticClass:"block",attrs:{"animated":false}},[_c('b-tab-item',{attrs:{"label":"Основные"}},[_c('b-field',{staticClass:"is-margin-top",attrs:{"label":"Название"}},[_c('b-input',{attrs:{"placeholder":"Название"},model:{value:(_vm.selected_client.name),callback:function ($$v) {_vm.$set(_vm.selected_client, "name", $$v)},expression:"selected_client.name"}})],1),_vm._v(" "),_c('b-field',{staticClass:"is-margin-top",attrs:{"label":"Помещение"}},[_c('b-input',{attrs:{"placeholder":"Помещение"},model:{value:(_vm.selected_client.room),callback:function ($$v) {_vm.$set(_vm.selected_client, "room", $$v)},expression:"selected_client.room"}})],1),_vm._v(" "),_c('b-field',{staticClass:"is-margin-top"},[_c('button',{staticClass:"button",on:{"click":function($event){_vm.save_client()}}},[_vm._v("сохранить")])])],1)],1):_c('div',{staticClass:"is-margin-top notification"},[_vm._v("\n                  Выберите устройство для быстрого редактирования.\n                ")])],1)])])]),_vm._v(" "),_c('b-tab-item',{attrs:{"label":"Админские"}},[_c('div',{staticClass:"columns is-margin-top"},[_c('div',{staticClass:"column is-two-thirds"},[_c('b-table',{attrs:{"data":_vm.admins,"selected":_vm.selected_client,"loading":_vm.data_loading,"paginated":""},on:{"update:selected":function($event){_vm.selected_client=$event}},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('b-table-column',{attrs:{"field":"room","label":"Помещение","width":"100","sortable":""}},[_vm._v("\n                    "+_vm._s(props.row.room)+"\n                  ")]),_vm._v(" "),_c('b-table-column',{attrs:{"field":"name","label":"Название","width":"100","sortable":""}},[_vm._v("\n                    "+_vm._s(props.row.name)+"\n                  ")]),_vm._v(" "),_c('b-table-column',{attrs:{"field":"name","label":"Страница","width":"100","sortable":""}},[_vm._v("\n                    "+_vm._s(props.row.current_page)+"\n                  ")]),_vm._v(" "),_c('b-table-column',{attrs:{"field":"status","label":"Статус","width":"100","sortable":""}},[(props.row.status === "online")?_c('span',{staticClass:"tag is-success"},[_vm._v(_vm._s(props.row.status))]):_vm._e(),_vm._v(" "),(props.row.status === "offline")?_c('span',{staticClass:"tag is-danger"},[_vm._v(_vm._s(props.row.status))]):_vm._e()]),_vm._v(" "),_c('b-table-column',{attrs:{"field":"lastseen","label":"Онлайн","width":"100","sortable":""}},[_vm._v("\n                    "+_vm._s(new Date(props.row.lastseen).toLocaleString())+"\n                  ")])]}}])})],1),_vm._v(" "),_c('div',{staticClass:"column is-one-third"},[_c('section',{staticClass:"is-margin-top box fast_edit"},[(_vm.selected_client.hasOwnProperty("_id"))?_c('b-tabs',{staticClass:"block",attrs:{"animated":false}},[_c('b-tab-item',{attrs:{"label":"Основные"}},[_c('b-field',{staticClass:"is-margin-top",attrs:{"label":"Название"}},[_c('b-input',{attrs:{"placeholder":"Название"},model:{value:(_vm.selected_client.name),callback:function ($$v) {_vm.$set(_vm.selected_client, "name", $$v)},expression:"selected_client.name"}})],1),_vm._v(" "),_c('b-field',{staticClass:"is-margin-top",attrs:{"label":"Помещение"}},[_c('b-input',{attrs:{"placeholder":"Помещение"},model:{value:(_vm.selected_client.room),callback:function ($$v) {_vm.$set(_vm.selected_client, "room", $$v)},expression:"selected_client.room"}})],1),_vm._v(" "),_c('b-field',{staticClass:"is-margin-top"},[_c('button',{staticClass:"button",on:{"click":function($event){_vm.save_client()}}},[_vm._v("сохранить")])])],1)],1):_c('div',{staticClass:"is-margin-top notification"},[_vm._v("\n                  Выберите устройство для быстрого редактирования.\n                ")])],1)])])]),_vm._v(" "),_c('b-tab-item',{attrs:{"label":"Автоматы"}},[_c('div',{staticClass:"columns is-margin-top"},[_c('div',{staticClass:"column is-two-thirds"},[_c('b-table',{attrs:{"data":_vm.vgms,"selected":_vm.selected_client,"loading":_vm.data_loading,"paginated":""},on:{"update:selected":function($event){_vm.selected_client=$event}},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('b-table-column',{attrs:{"field":"name","label":"Название","width":"100","sortable":""}},[_vm._v("\n                    "+_vm._s(props.row.name)+"\n                  ")]),_vm._v(" "),_c('b-table-column',{attrs:{"field":"status","label":"Статус","width":"100","sortable":""}},[(props.row.status === "online")?_c('span',{staticClass:"tag is-success"},[_vm._v(_vm._s(props.row.status))]):_vm._e(),_vm._v(" "),(props.row.status === "offline")?_c('span',{staticClass:"tag is-danger"},[_vm._v(_vm._s(props.row.status))]):_vm._e()]),_vm._v(" "),_c('b-table-column',{attrs:{"field":"lastseen","label":"Онлайн","width":"100","sortable":""}},[_vm._v("\n                    "+_vm._s(new Date(props.row.lastseen).toLocaleString())+"\n                  ")])]}}])})],1),_vm._v(" "),_c('div',{staticClass:"column is-one-third"},[_c('section',{staticClass:"is-margin-top box fast_edit"},[(_vm.selected_client.hasOwnProperty("_id"))?_c('b-tabs',{staticClass:"block",attrs:{"animated":false}},[_c('b-tab-item',{attrs:{"label":"Основные"}},[_c('b-field',{staticClass:"is-margin-top",attrs:{"label":"Название"}},[_c('b-input',{attrs:{"placeholder":"Название"},model:{value:(_vm.selected_client.name),callback:function ($$v) {_vm.$set(_vm.selected_client, "name", $$v)},expression:"selected_client.name"}})],1),_vm._v(" "),_c('b-field',{staticClass:"is-margin-top",attrs:{"label":"Номер GPIO"}},[_c('b-input',{attrs:{"placeholder":"Номер GPIO"},model:{value:(_vm.selected_client.params.gpio),callback:function ($$v) {_vm.$set(_vm.selected_client.params, "gpio", $$v)},expression:"selected_client.params.gpio"}})],1),_vm._v(" "),_c('b-field',{staticClass:"is-margin-top",attrs:{"label":"Время нажатия (мс)"}},[_c('b-input',{attrs:{"placeholder":"Время нажатия (мс)"},model:{value:(_vm.selected_client.params.press_by),callback:function ($$v) {_vm.$set(_vm.selected_client.params, "press_by", $$v)},expression:"selected_client.params.press_by"}})],1),_vm._v(" "),_c('b-field',{staticClass:"is-margin-top",attrs:{"label":"Время аренды (с)"}},[_c('b-input',{attrs:{"placeholder":"Время аренды (с)"},model:{value:(_vm.selected_client.params.booked_by),callback:function ($$v) {_vm.$set(_vm.selected_client.params, "booked_by", $$v)},expression:"selected_client.params.booked_by"}})],1),_vm._v(" "),_c('b-field',{staticClass:"is-margin-top",attrs:{"label":"Цена"}},[_c('b-input',{attrs:{"placeholder":"Цена"},model:{value:(_vm.selected_client.params.price),callback:function ($$v) {_vm.$set(_vm.selected_client.params, "price", $$v)},expression:"selected_client.params.price"}})],1),_vm._v(" "),_c('b-field',{staticClass:"is-margin-top"},[_c('button',{staticClass:"button",on:{"click":function($event){_vm.save_client()}}},[_vm._v("сохранить")])])],1)],1):_c('div',{staticClass:"is-margin-top notification"},[_vm._v("\n                  Выберите устройство для быстрого редактирования.\n                ")])],1)])])])],1)],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "pP30":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "t3l5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['login_method', 'error', 'success'],
  data: function data() {
    return {
      username: '',
      password: ''
    };
  },
  methods: {
    sign_in: function sign_in(username, password) {
      if (username === '' || password === '') return;
      var t = this;
      var form = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({ method: 'login', params: { username: username, password: password } });
      window.$.post(window.gw + 'api/user', { data: form }, function (r) {
        var d = JSON.parse(r);
        if (d.result === 'ok') {
          t.success();
          t.$parent.close();
        }
        if (d.result === 'error') {
          t.$toast.open({
            duration: 5000,
            message: d.params.msg,
            position: 'is-bottom',
            type: 'is-danger'
          });
        }
      });
    }
  }
});

/***/ }),

/***/ "ug3k":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "vzL1":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xB9i":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Observer__ = __webpack_require__("Iw1g");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Emitter__ = __webpack_require__("BDuk");




/* harmony default export */ __webpack_exports__["a"] = ({
  install: function install(Vue, connection) {
    var opts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    if (!connection) {
      throw new Error('[vue-native-socket] cannot locate connection');
    }

    var observer = new __WEBPACK_IMPORTED_MODULE_1__Observer__["a" /* default */](Vue, connection, opts);

    // Vue.prototype.$socket = observer.WebSocket

    Vue.mixin({
      created: function created() {
        var _this = this;

        var vm = this;
        var sockets = this.$options['sockets'];

        this.$options.sockets = new Proxy({}, {
          set: function set(target, key, value) {
            __WEBPACK_IMPORTED_MODULE_2__Emitter__["a" /* default */].addListener(key, value, vm);
            target[key] = value;
            return true;
          },
          deleteProperty: function deleteProperty(target, key) {
            __WEBPACK_IMPORTED_MODULE_2__Emitter__["a" /* default */].removeListener(key, vm.$options.sockets[key], vm);
            delete target.key;
            return true;
          }
        });

        if (sockets) {
          __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(sockets).forEach(function (key) {
            _this.$options.sockets[key] = sockets[key];
          });
        }
      },
      beforeDestroy: function beforeDestroy() {
        var _this2 = this;

        var sockets = this.$options['sockets'];
        clearTimeout(observer.reconnectTimeoutId);

        if (sockets) {
          __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(sockets).forEach(function (key) {
            delete _this2.$options.sockets[key];
          });
        }
      }
    });
  }
});

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_loginFormModal__ = __webpack_require__("b6qO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router_index__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__bus__ = __webpack_require__("14gb");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


// import store from './store'



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  data: function data() {
    this.is_logged_in();
    __WEBPACK_IMPORTED_MODULE_3__bus__["a" /* EventBus */].$on('ws_on_message', this.ws_on_message);
    return {
      active_tab: 'Stats',
      login_overlay: true,
      navigation: '',
      current_user: '',
      is_waiting_for_card: false
      // store: store
    };
  },
  methods: {
    active_tab_class: function active_tab_class(name) {
      if (name === this.active_tab) return 'is-active';
      return '';
    },
    is_logged_in: function is_logged_in() {
      var t = this;
      t.login_overlay = true;
      var form = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({ method: 'is_logged_in', params: {} });
      window.$.post(window.gw + 'api/user', { data: form }, function (r) {
        var d = JSON.parse(r);
        if (d.result === 'error') {
          __WEBPACK_IMPORTED_MODULE_2__router_index__["a" /* default */].push('home');
          t.$modal.open({
            parent: this,
            component: __WEBPACK_IMPORTED_MODULE_1__components_loginFormModal__["a" /* default */],
            hasModalCard: true,
            canCancel: false,
            props: {
              success: t.login_success
            }
          });
        } else {
          t.current_user = d.params.username;
          t.login_overlay = false;
        }
      });
    },
    login_success: function login_success() {
      this.is_logged_in();
      // setTimeout(function () { location.reload() }, 500)
    },
    logout: function logout() {
      // var t = this
      var form = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({ method: 'logout', params: {} });
      window.$.post(window.gw + 'api/user', { data: form }, function (r) {
        var d = JSON.parse(r);
        if (d.result === 'ok') location.reload();
      });
    },
    ws_on_message: function ws_on_message(message) {
      console.log('App', 'ws_on_message', message);
      message = JSON.parse(message);
      var method = message.method;
      var params = message.params;
      if (method === 'handshake') this.ws_handshake();
      if (method === 'set_device_id') this.ws_set_device_id(params);
      if (method === 'ping') this.ws_send_ping();
    },
    ws_handshake: function ws_handshake() {
      var c = { method: 'handshake', params: { 'device_type': 'admin', 'version': window.version } };

      if (localStorage.getItem('device_id')) {
        c.params.device_id = localStorage.getItem('device_id');
      }

      this.$socket.send(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(c));
      console.log(c);
      c = { method: 'page_change', params: { 'from': this.$route.path, 'to': this.$route.path } };
      this.$socket.send(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(c));
      console.log(c);
    },
    ws_set_device_id: function ws_set_device_id(params) {
      localStorage.setItem('device_id', params.device_id);
    },
    ws_send_ping: function ws_send_ping() {
      var c = { method: 'ping', params: {} };
      this.$socket.send(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(c));
    }
  }
});

/***/ }),

/***/ "xX1n":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.53f66c7af52c5755a4a0.js